import { Component, ElementRef, HostListener, ViewChild, inject, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { ActivatedRoute, Route, Router } from '@angular/router';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { GlobalConstants } from 'src/app/services/global-constants';
import { DataService } from 'src/app/services/data.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import pptxgen from "pptxgenjs";
import { ExportService } from 'src/app/services/export.service';
import { MessageService, ConfirmationService, ConfirmEventType } from 'primeng/api';
import FileSaver from 'file-saver';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { Chart, ChartConfiguration, ChartType, registerables } from 'chart.js';

@Component({
  selector: 'app-assessment-results',
  templateUrl: './assessment-results.component.html',
  styleUrl: './assessment-results.component.scss'
})
export class AssessmentResultsComponent {
  getColumnValueCount(row: any, column: string): number {
    const field = row.meta.fields.find((f: { field: { label: string; }; }) => f.field.label === column);
    return field ? field.value.length : 0;
  }

  @Input() from: string = 'assessment';
  @Input() assessmentId: string = '';
  @Input() isChild: boolean = false;
  header: string = '';
  exportingPPT: boolean = false;
  links: link[] = [
    {
      name: 'رجوع',
      icon: 'pi pi-angle-right',
      link: ``,
    },
  ];
  breadcrumbs: breadcrumb[] = [];
  queryParams: any = {};
  stats: stat[] = [];
  messages: any[] = [];
  invitees: any[] = [];
  graphData: any[] = [];
  userResults: any[] = [];
  activeTabIndex: number = 0;
  activeResultTabIndex: number = 0;
  tabIndex: number = 0;
  currentQBankId: string = "";
  chartData: any;
  barChartOptions = {
    plugins: {
      legend: {
        labels: {
          font: {
            size: 14,
            family: 'SSTArabic'
          }
        },
        display: false
      }
    },
    scales: {
      x: {
        ticks: {
          font: {
            size: 12,
            family: 'SSTArabic'
          },
          color: '#787878',
          autoSkip: false, // Keeps all labels
          maxTicksLimit: 10, // Limits number of visible labels
          maxRotation: 90,
        }
      },
      y: {
        ticks: {
          font: {
            size: 10,
            family: 'SSTArabic'
          },
          color: '#787878',
          stepSize: 10, // Adjusted for cleaner percentage steps
          callback: function (value: string) {
            return value + '%'; // Adds '%' symbol to each tick
          }
        },
        max: 100 // Ensures Y-axis is capped at 100
      }
    }
  };
  page: number = 1;
  rows: number = 10;
  first = 1;

  totalInvitees: number = 0;
  totalUserResults: number = 0;
  types: any = [];
  dropType: any
  filteredInvitees: any;
  filteredResults: any;
  noGraphs: string[] = ['RANK_ORDER', 'DATE_TIME', 'PRESENTATION_TEXT', 'SECTION_HEADING', 'SECTION_SUB_HEADING'];
  assessment: any;
  showInviteDropdown: boolean = false;
  showResultDropdown: boolean = false;

  skelition: boolean = false;
  courseId: string = '';
  ratingFor: string = '';
  ratingForID: string = '';
  isRating: boolean = false;
  downloadExcel: boolean = false
  regenAttempt: boolean = false
  sendCert: boolean = false
  external: any = null
  searchText: string = ''
  isFilterApplied: boolean = false
  emailModal: boolean = false
  emailText: string = "";
  emailLink: string = "";
  selectedUsers: string[] = [];
  source: string = "";
  activeTRTabIndex: number = 0;
  tFrom: string = '';
  TypeId: string = '';
  Main: number = 0;
  totalGradesData: any[] = [];

  chartColors = ["802d7e", "1b75bb", "5b5095", "2e3171", "3d2b63"];

  cacheCount: number = 0;
  downloadExcelCache: boolean = false
  downloadCWExcel: boolean = false
  downloadPdf: boolean = false
  downloadPdfExcel: boolean = false
  assessmentIds: any;

  exportMenuItems: any[] = [];

  printableData: any = null;
  isPrinting: boolean = false;
  private sanitizer = inject(DomSanitizer);

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router,
    private exportService: ExportService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
  ) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    pdfMake.fonts = {
      DINNextLTArabic: {
        normal: GlobalConstants.apiURL + 'public/fonts/DINNextLTArabic-Regular.ttf',
        bold: GlobalConstants.apiURL + 'public/fonts/DINNextLTArabic-Bold.ttf',
        italics: GlobalConstants.apiURL + 'public/fonts/DINNextLTArabic-Light.ttf',
        bolditalics: GlobalConstants.apiURL + 'public/fonts/DINNextLTArabic-Heavy.ttf'
      }
    }
    // Dynamically fetch the logo image and add it to pdfMake.vfs
    fetch(GlobalConstants.apiURL + 'public/fonts/sbc_logo.png')
      .then(async (response) => {
        const blob = await response.blob();
        const reader = new FileReader();
        reader.onloadend = () => {
          // Remove the prefix "data:image/png;base64," for pdfMake.vfs
          const base64 = (reader.result as string).split(',')[1];
          pdfMake.vfs['sbc_logo.png'] = base64;
        };
        reader.readAsDataURL(blob);
      })
      .catch((err) => {
        console.error('Failed to load sbc_logo.png', err);
      });
  }

  ngOnInit() {
    this.header = this.translate(this.from + ' Results');
    this.breadcrumbs = [
      { name: this.translate(this.from), link: `/${this.from}/` },
      { name: this.translate(this.from + ' Results'), link: `/${this.from}/results/` },
    ];
    this.types = [
      { id: 1, label: this.translate('Internal Users') },
      { id: 2, label: this.translate('External Users') }
    ];

    this.initializeMenuItems();

    if (this.isChild && this.assessmentId) {
      this.fetchMainData().then(() => {
        this.header = this.assessment.name;
        this.fetchData().then(() => {
          this.fetchGraphData();
          this.fetchCacheExcelCount();
        });
      });
      return;
    }

    this.route.queryParams.subscribe(params => {

      if (params['ids']) {
        this.assessmentIds = params['ids'];
      }

      if (params['page'] && params['rows']) {
        this.page = Number(params['page']);
        this.rows = Number(params['rows']);
      }

      if (params['external']) {
        this.external = params['external'];
      }

      if (params['searchText']) {
        this.searchText = params['searchText'];
      }

      if (params['QBankId']) {
        this.currentQBankId = params['QBankId'];
      }

      if (params['tabIndex']) {
        const savedTabIndex = +params['tabIndex'];
        if (!isNaN(savedTabIndex)) {
          this.tabIndex = savedTabIndex;
        }
      }

      if (params['courseId']) {
        this.courseId = params['courseId'];
      }

      if (params['ratingFor']) {
        this.ratingFor = params['ratingFor'];
        this.isRating = true;
      }

      if (params['ratingForID']) {
        this.ratingForID = params['ratingForID'];
        this.isRating = true;
      }

      if (params['activeTabIndex']) {
        const activeTabIndex = +params['activeTabIndex'];
        if (!isNaN(activeTabIndex)) {
          this.activeTabIndex = activeTabIndex;
        }
      }

      if (params['tabResultIndex']) {
        const tabResultIndex = +params['tabResultIndex'];
        if (!isNaN(tabResultIndex)) {
          this.activeResultTabIndex = tabResultIndex;
        }
      }

      if (params['activeTRTabIndex']) {
        const activeTRTabIndex = +params['activeTRTabIndex'];
        if (!isNaN(activeTRTabIndex)) {
          this.activeTRTabIndex = activeTRTabIndex;
        }
      }

      if (params['from']) {
        this.tFrom = params['from'];
      }

      if (params['_id']) {
        this.courseId = params['_id'];
      }

      if (params['source']) {
        this.source = params['source'];
      }

      if (params['TypeId']) {
        this.TypeId = params['TypeId'];
      }

      if (params['Main']) {
        this.Main = params['Main'];
      }

      if (this.assessmentId) {
        this.fetchMainData().then(() => {
          if (this.source == 'training') {
            this.breadcrumbs[2].name = this.assessment.name;
          }
          else {
            this.breadcrumbs[1].name = this.assessment.name;
          }
          this.header = this.assessment.name
          this.fetchData().then(() => {
            this.fetchGraphData();
            this.fetchCacheExcelCount();
          });
        });
      }
    })

    this.route.params.subscribe(params => {

      console.log("params", params);
      if (typeof params['assessmentId'] === 'string' && params['assessmentId'].includes('%')) {
        let vars = "assessmentId=" + params['assessmentId'].replace(/%3F/g, '&').replace(/%3D/g, '=').replace(/%253F/g, '&').replace(/%253D/g, '=');
        let paramObj: { [key: string]: string } = {};
        vars.split('&').forEach((pair: string) => {
          const [key, value] = pair.split('=');
          if (key && value !== undefined) {
            paramObj[key] = decodeURIComponent(value);
          }
        });
        paramObj['from'] = params['from'];
        console.log("paramObj", paramObj);
        params = paramObj
      }

      this.assessmentId = params['assessmentId'];
      this.from = params['from'];
      this.header = this.translate(this.from + ' Results');

      let queryParams: any = {}
      if (this.source == 'training') {
        queryParams['_id'] = this.courseId;
        queryParams['from'] = this.tFrom;
        queryParams['activeTRTabIndex'] = this.activeTRTabIndex;

        this.links[0].link = '/training/training-results/' + this.courseId;
        this.links[0].queryParams = queryParams;
        this.breadcrumbs[0] = {
          name: this.translate('Training'),
          link: `/training/training-page/` + this.courseId,
          queryParams: { _id: this.courseId, from: this.tFrom }
        };
        this.breadcrumbs[1] = {
          name: this.translate('Training Results'),
          link: `/training/training-results/` + this.courseId,
          queryParams: { _id: this.courseId, from: this.tFrom, activeTRTabIndex: this.activeTRTabIndex }
        };
        this.breadcrumbs[2] = {
          name: this.translate(this.from + ' Results'),
          link: `/${this.from}/results/` + this.assessmentId,
          queryParams: { _id: this.courseId, from: this.tFrom, activeTRTabIndex: this.activeTRTabIndex, source: this.source }
        };
      }
      else {
        if (this.from == 'assessment') {
          queryParams['QBankId'] = this.currentQBankId;
          queryParams['tabIndex'] = this.tabIndex;
        }
        else {
          queryParams['TypeId'] = this.TypeId;
        }

        if (this.Main) {
          this.links[0].link = `/${this.from}`
        }
        else {
          this.links[0].link = `/${this.from}/add-question/` + this.assessmentId;
        }
        this.links[0].queryParams = queryParams;

        this.breadcrumbs[0] = {
          name: this.translate(this.from),
          link: `/${this.from}`,
          queryParams: queryParams
        };

        this.breadcrumbs[1] = {
          name: this.translate(this.from + ' Results'),
          link: `/${this.from}/results/` + this.assessmentId,
          queryParams: queryParams
        };
      }

      if (this.assessmentId) {
        this.fetchMainData().then(() => {
          this.header = this.assessment.name
          if (this.source == 'training') {
            this.breadcrumbs[2].name = this.assessment.name;
          }
          else {
            this.breadcrumbs[1].name = this.assessment.name;
          }
          this.fetchData().then(() => {
            this.fetchGraphData();
            this.fetchCacheExcelCount();
          });
        });
      }
    });
  }

  async exportToPPT() {
    try {
      this.skelition = true;
      let pres = new pptxgen();
      let tgd = JSON.parse(JSON.stringify(this.totalGradesData || []));
      let allData = tgd[3] || null;



      const fontFace = "DIN Next LT Arabic";

      pres.defineSlideMaster({
        title: "MASTER_SLIDE",
        background: { color: "FFFFFF" },
        objects: [
          { text: { text: this.assessment.name.toString(), options: { x: '4%', y: '30%', w: 5.5, h: 0.75, fontSize: 30, bold: true, fontFace } } },
          { image: { x: '70%', y: '85%', w: '25%', h: '10%', path: "assets/sbc_logo.png" } },
        ],
      });

      pres.addSlide({ masterName: "MASTER_SLIDE" });

      //Top Stats
      let stats = tgd[4] || [];
      if (stats) {
        let slide = pres.addSlide();
        slide.addText(":بيانات عامة ", { x: '76%', y: '2%', w: 5.5, h: 0.75, fontSize: 18, bold: true, fontFace });
        let tableData: any[] = [
          [
            { text: this.translate('Title'), options: { bold: true, align: 'right' } },
            { text: this.translate('statistics'), options: { bold: true, align: 'right' } }
          ].reverse()
        ];
        for (let item of stats) {
          tableData.push([
            { text: this.translate(item?.key), options: { align: 'right' } },
            { text: item?.value?.value ?? '', options: { align: 'right' } }
          ].reverse());
        }
        slide.addTable(tableData, { border: { pt: 1, color: '808080', type: 'solid' }, y: '15%', autoPage: true, fontFace, align: 'right' });
      }

      //Pi Charts
      let finalGradeData = [tgd[0], tgd[1]];


      if (this.from == 'assessment') {
        let slideIndex = 0;
        for (let data of finalGradeData) {
          let slide = pres.addSlide();
          let chartData: any[] = [];

          for (let dataset of data.datasets) {
            chartData.push({ labels: data.labels, values: dataset.data });
          }

          // Add heading for slide 3 (first pie chart)
          if (slideIndex === 0) {
            slide.addText("النسب المئوية للمشاركين حسب درجاتهم", { x: '40%', y: 0.3, w: 5.5, h: 0.4, fontSize: 18, bold: true, fontFace });
            slide.addChart(pres.ChartType.pie, chartData, { x: 1, y: 0.8, w: 8, h: 4.5, chartColors: this.chartColors, showLabel: false, dataLabelFontFace: fontFace, legendFontFace: fontFace, fontFace, titleFontFace: fontFace, legendFontSize: 10, dataLabelFontSize: 10, showLegend: true, showPercent: true });
          }
          // Add heading for slide 4 (second pie chart)
          else if (slideIndex === 1) {
            slide.addText("إجمالي عدد الإجابات الصحيحة للمشاركين", { x: '40%', y: 0.3, w: 5.5, h: 0.4, fontSize: 18, bold: true, fontFace });
            slide.addChart(pres.ChartType.pie, chartData, { x: 1, y: 0.8, w: 8, h: 4.5, chartColors: this.chartColors, showLabel: false, dataLabelFontFace: fontFace, legendFontFace: fontFace, fontFace, titleFontFace: fontFace, legendFontSize: 10, dataLabelFontSize: 10, showLegend: true, showPercent: true });
          }
          else {
            slide.addChart(pres.ChartType.pie, chartData, { x: 1, y: 1, w: 8, h: 4, chartColors: this.chartColors, showLabel: false, dataLabelFontFace: fontFace, legendFontFace: fontFace, fontFace, titleFontFace: fontFace, legendFontSize: 10, dataLabelFontSize: 10, showLegend: true, showPercent: true });
          }
          slideIndex++;
        }
      }



      //More Pi charts with heading
      let totalGrades = this.totalGradesData[2];
      // if (!!totalGrades && this.from == 'assessment'){
      //   let chartIndex = 0;
      //   for (let data of totalGrades) {
      //     let slide = pres.addSlide();
      //     let chartData: any[] = [];

      //     for (let dataset of data.datasets) {
      //       chartData.push({ labels: data.labels, values: dataset.data });
      //     }

      //     console.log('DATA', data);

      //     let title = typeof data?._id === 'string' ? data?._id : data?._id?.label;

      //     // Add heading for slide 5 (first chart in this section)
      //     if (chartIndex === 0) {
      //       slide.addText("تمثل هذه الأرقام نسب الإجابات الصحيحة.", { x: '40%', y: 0.3, w: 5.5, h: 0.4, fontSize: 18, bold: true, fontFace });
      //       slide.addText([{ text: title, options: { x: '40%', y: 0.7, w: 5.5, h: 0.4, fontSize: 16, bold: true, fontFace } }]);
      //       slide.addChart(pres.ChartType.pie, chartData, { x: 1, y: 1.2, w: 8, h: 4.5, chartColors: this.chartColors, titleFontFace: fontFace, legendFontFace: fontFace, fontFace, showLabel: false, legendFontSize: 10, dataLabelFontSize: 10, showLegend: true, showPercent: true });
      //     } else {
      //       slide.addText([{ text: title, options: { x: '40%', y: '20%', w: 5.5, h: 0.75, fontSize: 18, bold: true, fontFace } }]);
      //       slide.addChart(pres.ChartType.pie, chartData, { x: 1, y: 3, w: 8, h: 4, chartColors: this.chartColors, titleFontFace: fontFace, legendFontFace: fontFace, fontFace, showLabel: false, legendFontSize: 10, dataLabelFontSize: 10, showLegend: true, showPercent: true });
      //     }
      //     chartIndex++;
      //   }
      // }


      //Card data in table
      let keys = [
        'Overall average for the assessment in percentage',
        'Overall average for the assessment in marks',
        'Overall average for the assessment in grades'
      ];
      if (!!allData && this.from == 'assessment') {
        let percentage = allData['Overall average for the assessment in percentage']?.value;
        let marks = allData['Overall average for the assessment in marks']?.value;
        let grades = allData['Overall average for the assessment in grades']?.value;
        const tableData: any[] = [];
        tableData.push([{ text: this.translate(keys[0]), options: { bold: true } }, { text: this.translate(keys[1]), options: { bold: true } }, { text: this.translate(keys[2]), options: { bold: true } }]);
        tableData.push([percentage, marks, grades]);
        let slide = pres.addSlide();
        slide.addText(":المعدل العام", { x: '76%', y: '2%', w: 5.5, h: 0.75, fontSize: 18, bold: true, fontFace });
        slide.addTable(tableData, { border: { pt: 1, color: '808080', type: 'solid' }, y: '15%', autoPage: true, fontFace });
      }

      // Sourcing Graph Data
      const sourceGraphData = this.from === 'survey' ? this.graphData : (tgd[5] || this.graphData);

      const allQuestions = [
        ...(this.assessment.questions || []),
        ...(this.assessment.externalQuestions || [])
      ];

      // Prepare graph data with ordering and fallbacks
      const graphPromises = (sourceGraphData || []).map(async (g: any, i: number) => {
        const entry = { ...g };
        
        const qObj = allQuestions.find((aq: any) => {
          const gId = g._id ? g._id.toString() : '';
          const gText = g.questionText ? g.questionText.toString() : '';
          
          return aq._id === g._id || 
                 aq.questionCode === g._id || 
                 aq.questionCode === g.questionText ||
                 gId === `${aq.questionCode}_` ||
                 gId === `${aq._id}_` ||
                 (aq.questionText && aq.questionText === g.questionText && gText.length > 5);
        });

        let resolvedText = g.questionText;
        if ((!resolvedText || resolvedText === g._id) && qObj) {
            resolvedText = qObj.questionText || 
                          (qObj.meta?.fields && qObj.meta.fields[0]?.label) || 
                          qObj.questionCode || 
                          qObj._id;
        }

        entry.questionText = this.replaceAlIsmWithAlSual(resolvedText || g.questionText || g._id);
        entry.order = qObj ? (qObj.order ?? 999) : 999;
        entry.isValidQuestion = !!qObj;

        // Ensure graphData is populated for rating/smiling if it came from the bulk graph
        if (g.type === 'smile' || g.type === 'rate') {
          if (!g.graphData || g.graphData.length === 0) {
             if (g.type === 'smile') entry.graphData = this.getSmileData(g.data, qObj);
             if (g.type === 'rate') entry.graphData = this.getStartData(g.data, qObj);
          }
        }

        let correctAnsText = g.meta?.correct || g.meta?.correctAnswer || g.correctAnswer || g.correct;
        if (!correctAnsText && qObj) {
            correctAnsText = qObj.correctAnswer || 
                             qObj.options?.find((o:any) => o.isCorrect)?.optionText || 
                             qObj.options?.find((o:any) => o.correct)?.text || 
                             qObj.options?.find((o:any) => o.correct)?.title || 
                             qObj.meta?.correct || 
                             qObj.meta?.correctAnswer;
            
            if (!correctAnsText && qObj.meta?.fields && Array.isArray(qObj.meta.fields)) {
              let deepCorrects = qObj.meta.fields.map((f: any) => {
                if (f.correct) return `${f.label}: ${f.correct}`;
                if (f.field?.correct) return `${f.field.label}: ${f.field.correct}`;
                return null;
              }).filter(Boolean);
              
              if (deepCorrects.length > 0) {
                correctAnsText = deepCorrects;
              }
            }
            
            if (Array.isArray(correctAnsText)) {
              correctAnsText = correctAnsText.join(' | ');
            }
        }
        entry.correctAnswerText = correctAnsText;

        return entry;
      });

      let printableGraphData = (await Promise.all(graphPromises)).filter((item: any) => item.isValidQuestion);
      
      // Sort by Assessment Order
      printableGraphData.sort((a: any, b: any) => (a.order || 0) - (b.order || 0));

      // Bar and tables - OU question: chart only (no table slide)
      for (let data of printableGraphData) {

        
        // SECTION HEADING (info type)
        if (data.type === 'info') {
          let slide = pres.addSlide();
          slide.addText(data.questionText, { x: 0.5, y: '40%', w: 9, fontSize: 24, bold: true, fontFace, align: 'center', color: '47276d' });
          continue;
        }
        // OU_TREE_DROPDOWN: chart only in PPT (no table)
        if (data.questionType === 'OU_TREE_DROPDOWN' && data.graphData) {
          let slide = pres.addSlide();
          let chartData: any[] = [];
          for (let dataset of data.graphData.datasets) {
            chartData.push({
              name: dataset.label,
              labels: data.graphData.labels.flat(Infinity),
              values: dataset.counts || dataset.data
            });
          }
          slide.addChart(pres.ChartType.bar, chartData, {
            title: data.questionText,
            x: 1, y: 1, w: 8, h: 4,
            showTitle: true, titleFontFace: fontFace, titleFontSize: 12,
            legendFontFace: fontFace, legendFontSize: 10, fontFace, dataLabelFontSize: 10,
            showValue: true, chartColors: this.chartColors, showLabel: false, showLegend: true, showPercent: false,
            valAxisLabelFontFace: fontFace, catAxisLabelFontFace: fontFace, catAxisLabelFontSize: 8,
            valAxisLineShow: true, catAxisLineShow: true
          });

          if (data.correctAnswerText) {
            slide.addText(`${this.translate('Correct Answer')}: ${data.correctAnswerText}`, {
              x: 0.5, y: 5.2, w: 9, fontSize: 12, color: '155724', bold: true, fontFace, align: 'right'
            });
          }
          continue;
        }
        // BAR CHART
        if (data.type === 'bar') {
          if (!data.graphData || !data.graphData.datasets || !data.graphData.labels) continue;
          let slide = pres.addSlide();
          let chartData: any[] = [];
          
          for (let dataset of data.graphData.datasets) {
            // Use counts instead of percentages
            chartData.push({
              name: dataset.label,
              labels: data.graphData.labels.flat(Infinity),
              values: dataset.counts || dataset.data
            });
          }
          
          slide.addChart(pres.ChartType.bar, chartData, {
            title: data.questionText,
            x: 1,
            y: 1.2,
            w: 8,
            h: 4,
            showTitle: true,
            titleFontFace: fontFace,
            titleFontSize: 14,
            legendFontFace: fontFace,
            legendFontSize: 10,
            fontFace,
            dataLabelFontSize: 10,
            showValue: true,
            chartColors: this.chartColors,
            showLabel: false,
            showLegend: true,
            showPercent: false,
            valAxisLabelFontFace: fontFace,
            catAxisLabelFontFace: fontFace,
            catAxisLabelFontSize: 8,
            valAxisLineShow: true,
            catAxisLineShow: true
          });

          if (data.correctAnswerText) {
            slide.addText(`${this.translate('Correct Answer')}: ${data.correctAnswerText}`, {
              x: 0.5, y: 5.2, w: 9, fontSize: 12, color: '155724', bold: true, fontFace, align: 'right'
            });
          }
        }
        // TEXT TABLE (single row)
        else if (data.type === 'text') {
          // Handle open text answers: each answer in its own row, RTL
          let tableData: any[] = [];
          // Add header
          if (data.data.labels && data.data.labels.length > 0) {
            let header = data.data.labels.map((label: string) => ({ text: label, options: { bold: true, align: 'right' } }));
            tableData.push(header.reverse());
          }
          // Each answer is in data.data.datasets[0].data (array of arrays)
          if (
            data.data.datasets &&
            Array.isArray(data.data.datasets) &&
            data.data.datasets.length > 0 &&
            Array.isArray(data.data.datasets[0].data)
          ) {
            for (const answerArr of data.data.datasets[0].data) {
              // answerArr is an array, usually with one string (the answer)
              let row = answerArr.map((val: any) => ({ text: val?.toString() ?? '', options: { align: 'right' } }));
              tableData.push(row.reverse());
            }
          }
          if (data.data && data.data.datasets && data.data.labels && tableData.length > 1) {
            let slide = pres.addSlide();
            slide.addText(data.questionText, { x: 0.5, y: 0.2, w: 9, h: 0.5, fontSize: 16, bold: true, fontFace, align: 'right' });
            slide.addTable(this.cleanArray(tableData), {
              border: { pt: 1, color: '808080', type: 'solid' },
              y: 0.8,
              autoPage: true,
              fontFace,
              align: 'right'
            });
            if (data.correctAnswerText) {
              slide.addText(`${this.translate('Correct Answer')}: ${data.correctAnswerText}`, {
                x: 0.5, y: 5.2, w: 9, fontSize: 12, color: '155724', bold: true, fontFace, align: 'right'
              });
            }
          }
        }
        // RANK ORDER
        else if (data.type === 'rank_order') {
          if (!data.data || !data.data.labels || !data.data.ranks) continue;
          let slide = pres.addSlide();
          slide.addText(data.questionText, { x: 0.5, y: 0.2, w: 9, h: 0.5, fontSize: 16, bold: true, fontFace, align: 'right' });
          
          let tableHeader = [
            { text: this.translate('Item'), options: { bold: true, align: 'right' } },
            ...data.data.ranks.map((r: any) => ({ text: `${this.translate('Rank')} ${r}`, options: { bold: true, align: 'center' } }))
          ];
          let tableData: any[] = [tableHeader];

          for (const label of data.data.labels) {
            let row = [
              { text: label, options: { align: 'right', bold: true } },
              ...data.data.ranks.map((r: any) => ({ text: (data.data.distribution[label]?.[r] || 0).toString(), options: { align: 'center' } }))
            ];
            tableData.push(row);
          }
          
          slide.addTable(this.cleanArray(tableData), {
            border: { pt: 1, color: '808080', type: 'solid' },
            y: 0.8,
            autoPage: true,
            fontFace,
            align: 'right'
          });
          if (data.correctAnswerText) {
            slide.addText(`${this.translate('Correct Answer')}: ${data.correctAnswerText}`, {
              x: 0.5, y: 5.2, w: 9, fontSize: 12, color: '155724', bold: true, fontFace, align: 'right'
            });
          }
        }

        // TABLE (multi-row, multi-column)
        else if (data.type === 'table') {
          if (!data.data || !data.data.labels || !data.data.datasets) continue;
          let slide = pres.addSlide();
          slide.addText(data.questionText, { x: 0.5, y: 0.2, w: 9, h: 0.5, fontSize: 16, bold: true, fontFace, align: 'right' });
          // Reverse labels and data for RTL and align right
          let tableHeader = [
            { text: this.translate(data.description || data.label || ''), options: { bold: true, align: 'right' } },
            ...data.data.labels.map((col: string) => ({ text: col, options: { bold: true, align: 'right' } }))
          ];
          let tableData: any[] = [tableHeader];
          for (const dataset of data.data.datasets) {
            if (!dataset.data) continue;
            let row = [
              { text: dataset.label?.toString() ?? '', options: { align: 'right' } },
              ...dataset.data.map((val: any) => ({ text: val?.toString() ? val?.toString() + '%' : '', options: { align: 'right' } }))
            ];
            tableData.push(row);
          }
          // Reverse each row for RTL
          tableData = tableData.map(row => row.reverse());
          slide.addTable(this.cleanArray(tableData), {
            border: { pt: 1, color: '808080', type: 'solid' },
            y: 0.8,
            autoPage: true,
            fontFace,
            align: 'right'
          });
          if (data.correctAnswerText) {
            slide.addText(`${this.translate('Correct Answer')}: ${data.correctAnswerText}`, {
              x: 0.5, y: 5.2, w: 9, fontSize: 12, color: '155724', bold: true, fontFace, align: 'right'
            });
          }
        }
        // CALENDAR (list of dates)
        else if (data.type === 'calander' || data.type === 'calendar') {
          let slide = pres.addSlide();
          let tableData: any[] = [
            [{ text: this.translate(data.questionText), options: { bold: true } }]
          ];
          if (Array.isArray(data.meta)) {
            for (let row of data.meta) {
              tableData.push([{ text: this.formatDate(row.value), options: {} }]);
            }
          }
          slide.addTable(this.cleanArray(tableData), {
            border: { pt: 1, color: '808080', type: 'solid' },
            autoPage: true,
            fontFace
          });
          if (data.correctAnswerText) {
            slide.addText(`${this.translate('Correct Answer')}: ${data.correctAnswerText}`, {
              x: 0.5, y: 5.2, w: 9, fontSize: 12, color: '155724', bold: true, fontFace, align: 'right'
            });
          }
        }
        // SMILE (images with counts)
        else if (data.type === 'smile') {

          let slide = pres.addSlide();
          slide.addText(this.translate(data.questionText), { x: 0.5, y: 0.2, fontSize: 18, bold: true, fontFace });
          
          const smileData = data.graphData || [];
          if (Array.isArray(smileData) && smileData.length > 0) {
            let tableData: any[] = [
              [
                { text: this.translate('Label'), options: { bold: true } },
                { text: this.translate('Image'), options: { bold: true } },
                { text: this.translate('Count'), options: { bold: true } }
              ]
            ];
            for (let item of smileData) {
              tableData.push([
                { text: item.label, options: {} },
                { text: '', options: { hyperlink: item.image } }, // Can't embed image, but can add link
                { text: item.count?.toString() ?? '', options: {} }
              ]);
            }
            slide.addTable(this.cleanArray(tableData), {
              border: { pt: 1, color: '808080', type: 'solid' },
              autoPage: true,
              fontFace
            });
            if (data.correctAnswerText) {
              slide.addText(`${this.translate('Correct Answer')}: ${data.correctAnswerText}`, {
                x: 0.5, y: 5.2, w: 9, fontSize: 12, color: '155724', bold: true, fontFace, align: 'right'
              });
            }
          } else {
            console.warn('PPT: SMILE data is empty for', data.questionText);
            slide.addText("No data available / لاتوجد بيانات", { x: 0.5, y: 2, fontSize: 14, color: 'FF0000', fontFace, align: 'center' });
          }
        }
        // RATE (star rating)
        else if (data.type === 'rate') {

          let slide = pres.addSlide();
          slide.addText(this.translate(data.questionText), { x: 0.5, y: 0.2, fontSize: 18, bold: true, fontFace });
          
          const ratingData = data.graphData || [];
          if (Array.isArray(ratingData) && ratingData.length > 0) {
            let tableData: any[] = [
              [
                { text: this.translate('Label'), options: { bold: true } },
                { text: this.translate('Value'), options: { bold: true } }
              ]
            ];
            for (let item of ratingData) {
              tableData.push([
                { text: item.label, options: {} },
                { text: item.value?.toString() ?? '', options: {} }
              ]);
            }
            slide.addTable(this.cleanArray(tableData), {
              border: { pt: 1, color: '808080', type: 'solid' },
              autoPage: true,
              fontFace
            });
            if (data.correctAnswerText) {
              slide.addText(`${this.translate('Correct Answer')}: ${data.correctAnswerText}`, {
                x: 0.5, y: 5.2, w: 9, fontSize: 12, color: '155724', bold: true, fontFace, align: 'right'
              });
            }
          } else {
            console.warn('PPT: RATE data is empty for', data.questionText);
            slide.addText("No data available / لاتوجد بيانات", { x: 0.5, y: 2, fontSize: 14, color: 'FF0000', fontFace, align: 'center' });
          }
        } else {
          console.log('PPT: Unhandled type or info skip:', data.type, 'for question:', data.questionText);
        }

      }



      //Table Data
      if (!!this.filteredResults && this.filteredResults.length > 0) {
        let participents: any[] = [[
          { text: "الجنس", options: { bold: true } },
          { text: "رقم الهاتف المحمول", options: { bold: true } },
          { text: "البريد الإلكتروني", options: { bold: true } },
          { text: "الاسم", options: { bold: true } }]];
        for (let user of this.filteredResults) {
          participents.push([(this.getUsername(user) ?? "").toString(), user.email ?? "", user.phone ?? "", user.gender ?? ""].reverse());
        }

        let slide = pres.addSlide();
        const pptTerm = (this.from || '').toLowerCase() === 'survey' ? 'المشاركين' : 'المختبرين';
        slide.addText(`:معلومات ${pptTerm}`, { x: '76%', y: '2%', w: 5.5, h: 0.75, fontSize: 18, bold: true, fontFace });
        slide.addTable(participents, { border: { pt: 1, color: '808080', type: 'solid' }, y: '15%', autoPage: true, fontFace });
      }

      pres.writeFile({ fileName: this.assessment.name.toString() + "_KGATE_ASSESSMENT.pptx" }).then(() => {
        this.skelition = false;
      });
    } catch (e) {
      console.log('PRINT ERROR', e);
      this.skelition = false;
    }
  }

  // Add this method inside your AssessmentResultsComponent class

  async exportToPDFwithData() {
    this.skelition = true;
    try {
      // Use existing frontend data instead of fetching from backend
      let cleanData: any = [...(this.filteredResults || [])];

      // If specific users are selected via checkboxes, filter to only those
      if (this.selectedUsers && this.selectedUsers.length > 0) {
        cleanData = cleanData.filter((res: any) => this.selectedUsers.includes(res._id));
      }

      // Pre-process cleaner names for results
      const processedResults = cleanData.map((res: any) => ({
        ...res,
        resolvedName: this.getUsername(res) || this.getName(res.name) || '-'
      }));

      // Work on a copy so we don't mutate original arrays
      const tgd = JSON.parse(JSON.stringify(this.totalGradesData || [])) as any[];

      const domainAnswers = tgd[2] || [];
      const allData = tgd[3] || null;
      let stats = tgd[4] || [];
      let worstPerformingQuestions = (allData && allData["Worst Performing Questions"]) || [];
      
      // Inject correct answer fallback for worst performing questions
      worstPerformingQuestions = worstPerformingQuestions.map((q: any) => {
        let correctAns = q.data?.meta?.correct || q.data?.meta?.correctAnswer || q.data?.correctAnswer;
        if (!correctAns && this.assessment?.questions) {
          const qObj = this.assessment.questions.find((aq: any) => aq._id === q.data?._id || aq.questionText === q.data?.questionText);
          if (qObj) {
            correctAns = qObj.correctAnswer || qObj.options?.find((o:any) => o.isCorrect)?.optionText || qObj.options?.find((o:any) => o.correct)?.text || qObj.options?.find((o:any) => o.correct)?.title;
          }
        }
        if (!q.data) q.data = {};
        if (!q.data.meta) q.data.meta = {};
        q.data.meta.correct = correctAns;
        return q;
      });

      // Dynamic Terminology (Assessment vs Survey)
      const isSurvey = (this.from || '').toLowerCase().includes('survey');
      const term = isSurvey ? 'المشاركين' : 'المختبرين';
      const termSingular = isSurvey ? 'مشارك' : 'مختبر';
      const subtitle = isSurvey ? 'تقرير نتائج الاستبيان' : 'تقرير نتائج الاختبار';

      // Map technical survey keys to professional labels (Matching Reference Image)
      const surveyStatMapping: { [key: string]: string } = {
        "Number of types of Surveys": "عدد نماذج الاستبيانات",
        "Number of Surveys": "عدد الاستبيانات",
        "Total Number of Surveys": "عدد الاستبيانات",
        "The Number of Questions": "إجمالي عدد الأسئلة",
        "Total number of questions": "إجمالي عدد الأسئلة",
        "Minimum number of questions in an survey": "الحد الأدنى لأسئلة الاستبيان",
        "Minimum question in one survey": "الحد الأدنى لأسئلة الاستبيان",
        "Minimum number of questions in an assessment": "الحد الأدنى لأسئلة التقييم",
        "Total Attendees": `إجمالي عدد ${term}`,
        "Total number of who attempted": "إجمالي عدد المستجيبين",
        "Internal Attendees": `عدد ${term} (داخلي)`,
        "Internal Attendees who attempted": "عدد المستجيبين (داخلي)",
        "External Attendees": `عدد ${term} (خارجي)`,
        "External Attendees  who attempted": "عدد المستجيبين (خارجي)",
        "Total number of who missed": "إجمالي عدد المتغيبين",
        "Total number of survey participants": `إجمالي عدد ${term}`,
        "Total number of respondents": "إجمالي عدد المستجيبين",
        "Total number of  missing respondents": `الفاقد من اجمالي ${term}`
      };

      // Ensure stats is an array of {key, value} objects for easier iteration
      if (stats && !Array.isArray(stats) && typeof stats === 'object') {
        stats = Object.keys(stats).map(key => {
          const mappedKey = this.from === 'survey' ? (surveyStatMapping[key] || key) : key;
          return {
            key: mappedKey,
            value: stats[key]
          };
        });
      } else if (!stats) {
        stats = [];
      } else if (Array.isArray(stats) && this.from === 'survey') {
        // Handle array of stats with mapping
        stats = stats.map(item => ({
          key: surveyStatMapping[item.key] || item.key,
          value: item.value
        }));
      }

      // Filter and Rename Stats Rows 
      if (Array.isArray(stats)) {
        // First map over to rename specific keys/labels
        stats = stats.map((s: any) => {
          if (s.key === 'Total Candidates' || s.key === 'Total number of candidates' || s.key === 'إجمالي عدد المرشحين للاختبار') {
            return { ...s, key: term === 'المختبرين' ? 'إجمالي عدد المختبرين' : 'إجمالي عدد المشاركين' };
          }
          return s;
        });

        // Then filter out unwanted rows
        stats = stats.filter((s: any) =>
          s.key !== 'Minimum number of questions in an assessment' &&
          s.key !== 'Minimum question in one survey' &&
          s.key !== 'الحد الأدنى لأسئلة الاختبار' &&
          s.key !== 'Total Attendees' &&
          s.key !== 'Total number of  missing respondents' &&
          s.key !== ' الفاقد من اجمالي المختبرين' &&
          s.key !== 'الفاقد من اجمالي المشاركين'
        );
      }

      // Generate Chart Images for Summary in parallel
      const [summaryPie1, summaryPie2] = await Promise.all([
        this.generateChartImage(tgd[0], 'pie'),
        this.generateChartImage(tgd[1], 'pie')
      ]);

      // Map raw data for tables matching the pie charts
      const summaryData1 = (tgd[0]?.labels || []).map((label: string, index: number) => ({
        label: label,
        value: tgd[0]?.datasets?.[0]?.data?.[index] || 0
      }));

      const summaryData2 = (tgd[1]?.labels || []).map((label: string, index: number) => ({
        label: label,
        value: tgd[1]?.datasets?.[0]?.data?.[index] || 0
      }));

      // Survey: use this.graphData (from survey-result/graph API) so external questions are included in PDF/PPT
      // Assessment: fetch a dedicated dataset that includes external (marks=0) questions,
      //             then re-apply the same per-question transforms used by the on-screen view.
      let sourceGraphData: any[] = [];
      if (this.from === 'survey') {
        sourceGraphData = this.graphData || [];
      } else {
        try {
          const bulkRes = await this.dataService.getData(
            `assessment-result/getBulkGraph?ids=${this.assessmentId}&includeExternal=true`
          );
          if (bulkRes && !bulkRes.error && Array.isArray(bulkRes.data)) {
            sourceGraphData = this.applyGraphRowTransforms(
              JSON.parse(JSON.stringify(bulkRes.data))
            );
            // PDF-only normalization: DATE_TIME has no chart-shaped data
            // (backend leaves type='bar' but empty), so render it like
            // CALENDAR – a list of submitted dates from row.meta. The
            // on-screen view is unaffected because this runs only inside
            // the PDF export path.
            sourceGraphData.forEach((g: any) => {
              if (g?.questionType === 'DATE_TIME') {
                g.type = 'calander';
                // DATE_TIME meta values are objects like {day,month,year[,hour,minute]}.
                // formatDate() expects a string/timestamp, so we convert each value
                // into an ISO-ish string ahead of time.  Other shapes (already a
                // string/Date/timestamp) pass through unchanged.
                if (Array.isArray(g.meta)) {
                  g.meta = g.meta.map((m: any) => {
                    const v = m?.value;
                    if (v && typeof v === 'object' && !(v instanceof Date) && (v.year || v.day || v.month)) {
                      const yyyy = String(v.year ?? '0000').padStart(4, '0');
                      const mm = String(v.month ?? '01').padStart(2, '0');
                      const dd = String(v.day ?? '01').padStart(2, '0');
                      const hh = String(v.hour ?? v.hours ?? '00').padStart(2, '0');
                      const mi = String(v.minute ?? v.minutes ?? '00').padStart(2, '0');
                      return { ...m, value: `${yyyy}-${mm}-${dd}T${hh}:${mi}:00Z` };
                    }
                    return m;
                  });
                }
              }
            });
            sourceGraphData.sort(this.compareInternalThenExternal);
          } else {
            sourceGraphData = tgd[5] || this.graphData || [];
          }
        } catch (err) {
          console.error('PDF includeExternal fetch failed, falling back to module dataset', err);
          sourceGraphData = tgd[5] || this.graphData || [];
        }
      }

      const internalQuestionsList = this.assessment.questions || [];
      const externalQuestionsList = this.assessment.externalQuestions || [];
      const allQuestions = [...internalQuestionsList, ...externalQuestionsList];

      // Resolve qObj from the right pool when the row is tagged isExternal,
      // otherwise the same questionCode in both pools causes the wrong title /
      // order / correct-answer to be picked up.
      const findQObj = (g: any, pool: any[]) => pool.find((aq: any) => {
        const gId = g._id ? g._id.toString() : '';
        const gText = g.questionText ? g.questionText.toString() : '';
        return aq._id === g._id ||
               aq.questionCode === g._id ||
               aq.questionCode === g.questionText ||
               gId === `${aq.questionCode}_` ||
               gId === `${aq._id}_` ||
               (aq.questionText && aq.questionText === g.questionText && gText.length > 5);
      });

      // Generate images for all question graphs in parallel
      const graphPromises = (sourceGraphData || []).map(async (g: any, i: number) => {
        const entry = { ...g };

        const preferredPool = g.isExternal === true
          ? externalQuestionsList
          : g.isExternal === false
            ? internalQuestionsList
            : allQuestions;
        const qObj = findQObj(g, preferredPool) || findQObj(g, allQuestions);

        let resolvedText = g.questionText;
        if ((!resolvedText || resolvedText === g._id) && qObj) {
            resolvedText = qObj.questionText || 
                          (qObj.meta?.fields && qObj.meta.fields[0]?.label) || 
                          qObj.questionCode || 
                          qObj._id;
        }


        entry.qIndex = `س${i + 1}`; // Temporary, will recalculate after sort
        entry.questionText = this.replaceAlIsmWithAlSual(resolvedText || g.questionText || g._id);
        entry.order = qObj ? (qObj.order ?? 999) : 999;


        if (g.type === 'bar' || g.type === 'pie') {
          entry.chartImage = await this.generateChartImage(g.graphData, g.type as any);
        } else if (g.type === 'smile' || g.type === 'rate') {
          // Construct a bar chart for smile and rate types
          const chartData = {
            labels: g.graphData.map((d: any) => d.label),
            datasets: [{
              data: g.graphData.map((d: any) => d.rawCount || d.value || d.count),
              backgroundColor: this.chartColors.map(c => '#' + c),
              label: this.translate('Count')
            }]
          };
          entry.chartImage = await this.generateChartImage(chartData, 'bar');
        } else if (g.type === 'rank_order') {
          // Arrangement questions (RANK_ORDER / DRAG_DROP) only need the
          // distribution table beneath the title; the chart adds no value
          // and frequently renders empty, so we intentionally skip it.
          entry.chartImage = null;
        } else if (g.questionType === 'OU_TREE_DROPDOWN' && g.graphData) {
          entry.chartImage = await this.generateChartImage(g.graphData, 'bar');
        } else if ((g.questionType === 'MULTI_POINT_SCALE' || g.questionType === 'MULTI_SELECT_SCALE') && (!g.data || !g.data.labels)) {
          // Fallback logic for empty matrix data: build from meta if available
          const matrixPreferred = g.isExternal === true
            ? externalQuestionsList
            : g.isExternal === false
              ? internalQuestionsList
              : allQuestions;
          const qObj = matrixPreferred.find((aq: any) => aq._id === g._id || aq.questionText === g.questionText)
            || allQuestions.find((aq: any) => aq._id === g._id || aq.questionText === g.questionText);
          
          if (qObj && qObj.meta) {
            entry.type = 'table';
            const labels = qObj.meta.columns || [];
            const datasets = (qObj.meta.fields || []).map((f: any) => {
              const field = f.field || f;
              // If we have results in g.data, use them, otherwise use 0
              let rowData = labels.map((col: string) => {
                const resultRow = g.data?.datasets?.find((d: any) => d.label === field.label);
                const colIndex = g.data?.labels?.indexOf(col);
                if (resultRow && colIndex !== -1) return resultRow.data[colIndex];
                return 0;
              });
              return { label: field.label, data: rowData };
            });
            entry.data = { labels, datasets };
          }
        }

        // --- Extract Correct Answer Text ---

        let correctAnsText = g.meta?.correct || g.meta?.correctAnswer || g.correctAnswer || g.correct;
        if (!correctAnsText && this.assessment) {
          const correctPreferred = g.isExternal === true
            ? externalQuestionsList
            : g.isExternal === false
              ? internalQuestionsList
              : allQuestions;
          const qObj = correctPreferred.find((aq: any) => aq._id === g._id || aq.questionText === g.questionText)
            || allQuestions.find((aq: any) => aq._id === g._id || aq.questionText === g.questionText);
          if (qObj) {
            correctAnsText = qObj.correctAnswer || 
                             qObj.options?.find((o:any) => o.isCorrect)?.optionText || 
                             qObj.options?.find((o:any) => o.correct)?.text || 
                             qObj.options?.find((o:any) => o.correct)?.title || 
                             qObj.meta?.correct || 
                             qObj.meta?.correctAnswer;
            
            // If the correct answer is inside complex meta fields (e.g. MULTI_POINT_SCALE, RANK_ORDER)
            if (!correctAnsText && qObj.meta?.fields && Array.isArray(qObj.meta.fields)) {
              let deepCorrects = qObj.meta.fields.map((f: any) => {
                if (f.correct) return `${f.label}: ${f.correct}`;
                if (f.field?.correct) return `${f.field.label}: ${f.field.correct}`;
                return null;
              }).filter(Boolean);
              
              if (deepCorrects.length > 0) {
                correctAnsText = deepCorrects;
              }
            }
            
            // Format array correct answers
            if (Array.isArray(correctAnsText)) {
              correctAnsText = correctAnsText.join(' | ');
            }
          }
        }
        entry.correctAnswerText = correctAnsText;

        entry.isValidQuestion = !!qObj; // Only questions found in assessment are valid

        return entry;

      });

      let printableGraphData = (await Promise.all(graphPromises)).filter((item: any) => item.isValidQuestion);

      // --- Sort: external questions first (by order), then internal questions (by order) ---

      printableGraphData.sort(this.compareInternalThenExternal);

      // --- Refresh Indices after sorting ---
      printableGraphData.forEach((item: any, idx: number) => {
        item.qIndex = `س${idx + 1}`;
      });

      // Prepare Grade Distribution Summary (Dynamic - Based on Assessment Criteria)
      const totalParticipants = summaryData1.reduce((sum: number, item: any) => sum + item.value, 0);

      // Extract dynamic categories from the first Criteria set (standard for target assessments)
      const criteriaData = allData['Criteria']?.[0]?.data || [];
      const targetLabels = criteriaData.map((c: any) => c.title);

      const gradeResults = targetLabels.map((label: string) => {
        const item = summaryData1.find((d: any) => d.label === label) || { label, value: 0 };
        const percentage = totalParticipants > 0 ? (item.value / totalParticipants * 100).toFixed(0) : '0';

        // Generalized analysis text using the dynamic label - consistent format for all
        let analysisText = `بلغت فئة ${label} ${percentage}% من إجمالي ${term}.`;

        return { ...item, percentage, analysisText };
      });

      // Calculate Max Count and Y-Axis Labels for dynamic scaling
      const maxVal = Math.max(...gradeResults.map((g: any) => g.value), 10);
      const yAxisMax = Math.ceil(maxVal / 50) * 50 || 50;
      const yAxisLabels = [];
      for (let i = yAxisMax; i >= 0; i -= 50) {
        yAxisLabels.push(i);
      }

      // Prepare Participant Information for the final section
      const participantInfo = processedResults.map((res: any) => ({
        name: res.resolvedName,
        email: res.email || '-'
      }));

      this.printableData = {
        assessmentName: this.assessment?.name || 'Assessment Results',
        fromLabel: this.from,
        subtitle: subtitle,
        term: term,
        termSingular: termSingular,
        isAnonymous: this.assessment?.anonymous === true,
        logo: 'assets/new-logo/SCBCLOGO-COLOR.svg',
        stats: stats,
        allData: allData,
        summaryPie1: summaryPie1,
        summaryPie2: summaryPie2,
        summaryData1: summaryData1,
        summaryData2: summaryData2,
        gradeResults: gradeResults,
        totalParticipants: totalParticipants,
        yAxisLabels: yAxisLabels,
        yAxisMax: yAxisMax,
        results: processedResults,
        participantInfo: participantInfo,
        graphData: printableGraphData,
        domainAnswers: domainAnswers,
        worstPerformingQuestions: worstPerformingQuestions,
        date: new Intl.DateTimeFormat('ar-EG', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        }).format(new Date())
      };

      setTimeout(() => {
        const btn = document.getElementById('print-results-btn');
        if (btn) {
          btn.click();
        } else {
          console.error('Print button not found');
        }
        this.skelition = false;
      }, 1000);

    } catch (e) {
      console.error('PRINT ERROR', e);
      this.skelition = false;
    }
  }

  async generateChartImage(graphData: any, chartType: 'bar' | 'pie' | 'doughnut' = 'bar'): Promise<string | null> {
    try {
      const ChartModule = await import('chart.js/auto');
      const Chart = ChartModule.Chart;

      // Force global defaults for font styling
      Chart.defaults.font.family = 'DINNextLTArabic';
      Chart.defaults.font.size = 24;
      Chart.defaults.font.weight = 'bold';
      Chart.defaults.color = '#000';

      const canvas = document.createElement('canvas');
      // Significantly increase width and leave height dynamic for bar charts
      canvas.width = chartType === 'pie' ? 1000 : 1600;
      canvas.style.display = 'none';
      document.body.appendChild(canvas);

      const ctx = canvas.getContext('2d');
      if (!ctx) {
        document.body.removeChild(canvas);
        return null;
      }

      const wrapText = (text: string, maxLength: number): string[] => {
        if (!text) return [];
        const words = text.split(' ');
        const lines: string[] = [];
        let currentLine = '';

        words.forEach(word => {
          if ((currentLine + word).length > maxLength) {
            lines.push(currentLine.trim());
            currentLine = word + ' ';
          } else {
            currentLine += word + ' ';
          }
        });
        lines.push(currentLine.trim());
        return lines;
      };

      let labels = Array.isArray(graphData.labels) ? graphData.labels : [];
      if (chartType === 'bar') {
        labels = labels.map((l: any) => {
          const text = Array.isArray(l) ? l.join(' ') : l;
          return wrapText(text, 50);
        });
        // Set dynamic height based on number of wrapped labels
        canvas.height = Math.max(700, labels.length * 150);
      } else {
        canvas.height = 700;
      }

      const chart = new Chart(ctx, {
        type: chartType as any,
        data: {
          labels: labels,
          datasets: graphData.datasets
        },
        options: {
          indexAxis: chartType === 'bar' ? 'y' : 'x',
          animation: { duration: 0 },
          responsive: false,
          layout: {
            padding: {
              left: 100, // Extra space for multi-line labels
              right: 60,
              top: 40,
              bottom: 40
            }
          },
          scales: chartType === 'bar' ? {
            x: {
              beginAtZero: true,
              ticks: { font: { size: 24, weight: 'bold' } }
            },
            y: {
              ticks: {
                autoSkip: false,
                font: { size: 20, weight: 'bold' }
              }
            }
          } : {},
          plugins: {
            legend: {
              display: chartType === 'pie',
              position: 'right',
              labels: { font: { size: 26, weight: 'bold' } }
            }
          }
        }
      });

      return new Promise((resolve) => {
        // Significantly increased timeout to ensure font is rendered on canvas
        setTimeout(() => {
          const image = canvas.toDataURL('image/png');
          chart.destroy();
          document.body.removeChild(canvas);
          resolve(image);
        }, 700);
      });
    } catch (e) {
      console.error('Error generating chart image:', e);
      return null;
    }
  }



  // 3) More Pie Charts with heading (as tables)
  // const totalGrades = tgd?.[2];
  // if (this.from === 'assessment' && Array.isArray(totalGrades) && totalGrades.length) {
  //   for (const data of totalGrades) {
  //     const title = typeof data?._id === 'string' ? data?._id : data?._id?.label;
  //     if (!data?.datasets?.length || !data?.labels?.length) continue;

  //     for (const dataset of data.datasets) {
  //       content.push({
  //         stack: [
  //           title ? {
  //             text: this.fixArabicText(title),
  //             style: 'h3',
  //             alignment: 'right',
  //             margin: [0, 0, 0, 6],

  //           } : {},
  //           {
  //             table: {
  //               headerRows: 1,
  //               widths: ['*', '*'],
  //               body: (() => {
  //                 const labels: any[] = Array.isArray(data.labels) && typeof (data.labels as any).flat === 'function'
  //                   ? (data.labels as any).flat(Infinity)
  //                   : data.labels;

  //                 const body: any[] = [
  //                   [
  //                     // For RTL, rightmost column first (Value then Label)
  //                     { text: this.fixArabicText('القيمة'), bold: true, alignment: 'right' },
  //                     { text: this.translate('Label'), bold: true, alignment: 'right' },
  //                   ]
  //                 ];

  //                 for (let i = 0; i < labels.length; i++) {
  //                   body.push([
  //                     // For RTL, rightmost column first (Value then Label)
  //                     { text: (dataset?.data?.[i] ?? '').toString(), alignment: 'right' },
  //                     { text: this.fixArabicText((labels[i] ?? '').toString()), alignment: 'right' },
  //                   ]);
  //                 }
  //                 return body;
  //               })(),
  //             },
  //             layout: 'lightHorizontalLines',
  //             margin: [0, 0, 0, 12],

  //           }
  //         ],
  //         pageBreak: 'after'
  //       });
  //     }
  //   }
  // }

  // 4) Card data table (":المعدل العام")



  getUsername(user: any) {
    console.log('DATA 2 USER', user)
    if (!user) return '';

    // Try different user name structures
    if (user.name) {
      if (typeof user.name === 'object' && user.name !== null) {
        // Handle object structure: {first, middle, last} or similar
        if (user.name.first || user.name.middle || user.name.last) {
          const parts = [user.name.first, user.name.middle, user.name.last].filter(Boolean);
          return parts.join(' ').trim();
        }
        // Handle object with values
        return this.getName(user.name);
      }
      // Handle string name
      return user.name.toString();
    }

    // Fallback to other possible fields
    if (user.firstName || user.lastName) {
      return [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
    }

    return '';
  }

  cleanArray(arr: any[]): any[] {
    let first = arr
      .filter(item => item !== null && item !== undefined && item !== "")
      .map(item => Array.isArray(item) ? this.cleanArray(item) : item);
    return first.filter(e => {
      if (Array.isArray(e)) {
        return e.length > 0;
      }
      return e != null && e != undefined && e != "";
    })
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  getStatValue(value: any): string {
    if (!value) return '-';
    if (typeof value === 'object') {
      return value.value ?? value.label ?? value.name ?? '-';
    }
    return value.toString();
  }

  /** Normalize type 'text' / OU_TREE_DROPDOWN table data so each row is an array (never a string). */
  getTextTableRows(g: any): any[] {
    const raw = g?.data?.datasets?.[0]?.data;
    if (!raw || !Array.isArray(raw)) return [];
    return raw.map((row: any) => (Array.isArray(row) ? row : [row]));
  }

  async fetchMainData() {
    try {
      let res = await this.dataService.getData(`${this.from}/id/${this.assessmentId}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.assessment = res.data;
      this.updateExportMenuItems();
      if (this.assessment && !this.route.snapshot.queryParams['tabResultIndex']) {
        this.activeResultTabIndex = this.assessment.accessType === 'BY_ACCOUNT' ? 1 : 0;
      }
    } catch (e) {
      console.log("error", e)
    }
  }

  /** When true, PDF export listing PII must not be offered (survey/assessment `anonymous`). */
  private isAnonymousAssessment(): boolean {
    return this.assessment?.anonymous === true;
  }

  async fetchData() {
    this.skelition = true;
    try {


      let url = `${this.from}-result/${this.assessmentId}/${this.page}/${this.rows}`;
      let queryParams = [];

      if (this.isRating) {
        queryParams.push(`courseId=${this.courseId}`, `ratingFor=${this.ratingFor}`, `ratingForID=${this.ratingForID}`);
      }

      if (this.external) {
        queryParams.push(`external=${this.external}`);
      }

      if (this.searchText) {
        queryParams.push(`searchText=${this.searchText}`);
      }

      if (queryParams.length > 0) {
        url += `?${queryParams.join('&')}`;
      }

      console.log("URL", url)

      let res = await this.dataService.getData(url);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.invitees = res.data.inviteesResult;
      // Filter invitees to get only unique by email, keeping the most recent one
      this.filteredInvitees = Object.values(
        this.invitees
          .sort((a: any, b: any) => new Date(b.submittedTime || 0).getTime() - new Date(a.submittedTime || 0).getTime())
          .reduce((acc: { [email: string]: any }, curr: any) => {
            if (curr.email) {
              if (!acc[curr.email]) {
                acc[curr.email] = curr;
              }
            }
            return acc;
          }, {})
      );
      console.log("FILTERED INVITEES", this.filteredInvitees);
      this.totalInvitees = res.data.inviteesCount;
      this.showInviteDropdown = this.totalInvitees > 0;
      this.userResults = res.data.userResults;
      this.filteredResults = Object.values(
        this.userResults
          .sort((a: any, b: any) => new Date(b.submittedTime || 0).getTime() - new Date(a.submittedTime || 0).getTime())
          .reduce((acc: { [email: string]: any }, curr: any) => {
            if (curr.email) {
              if (!acc[curr.email]) {
                acc[curr.email] = curr;
              }
            }
            return acc;
          }, {})
      );
      this.totalUserResults = res.data.userResultsCount;
      this.showResultDropdown = this.totalUserResults > 0;
      this.skelition = false;
    } catch (e) {
      this.skelition = false;
      console.log("error", e)
    }
  }

  testdata: any;

  onTabChange(event: any) {
    this.activeResultTabIndex = event.index;
    this.isFilterApplied = false;
    this.searchText = '';
    this.dropType = null;
    this.external = null;
    if (this.isChild) {
      this.page = 1;
      this.fetchData();
      return;
    }
    const queryParams = { ...this.route.snapshot.queryParams };
    queryParams['tabResultIndex'] = this.activeResultTabIndex;
    delete queryParams['page'];
    delete queryParams['rows'];
    delete queryParams['external'];
    delete queryParams['searchText'];
    console.log('TAB CHANGED')
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams
    });
  }

  navigateToSearch(event: any) {
    const val = event.target ? event.target.value : event;
    this.searchText = val;
    if (val != '') {
      this.isFilterApplied = true;
      if (this.isChild) {
        this.page = 1;
        this.fetchData();
        return;
      }
      let params = { searchText: val };
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: params,
        queryParamsHandling: 'merge',
      });
    }
    else {
      if (this.isChild) {
        this.page = 1;
        this.fetchData();
        return;
      }
      const queryParams = { ...this.route.snapshot.queryParams };
      delete queryParams['searchText'];
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: queryParams,
      });
    }
  }

  async fetchPdfData() {
    try {
      let url = `${this.from}-result/pdf?ids=${encodeURIComponent(this.assessmentId)}`;
      let res = await this.dataService.getData(url);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }

      return res.data;
    } catch (e) {
      console.log("error", e)
    }
  }

  async fetchExcelData() {
    try {

      let url = `${this.from}-result/excel?ids=${encodeURIComponent(this.assessmentId)}`;
      let queryParams = [];

      if (this.isRating) {
        queryParams.push(`courseId=${this.courseId}`, `ratingFor=${this.ratingFor}`, `ratingForID=${this.ratingForID}`);
      }

      if (this.external) {
        queryParams.push(`external=${this.external}`);
      }

      if (this.searchText) {
        queryParams.push(`searchText=${this.searchText}`);
      }

      if (queryParams.length > 0) {
        url += `?${queryParams.join('&')}`;
      }

      console.log("URL", url);

      let res = await this.dataService.getData(url);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }

      console.log("RES", res.data);
      return res.data
    } catch (e) {
      console.log("error", e)
    }
  }

  async fetchBulkExcelData() {
    try {
      let url = `${this.from}-result/bulkExcel?ids=${encodeURIComponent(this.assessmentId)}`;
      let res = await this.dataService.getData(url);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }

      console.log("RES", res.data);
      return res.data;
    } catch (e) {
      console.log("error", e);
    }
  }


  async fetchCacheExcelData() {
    try {

      let url = `cache-controller/getExcelData`;
      let res = await this.dataService.postData(url, { _id: this.assessmentId });
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }

      return res.data
    } catch (e) {
      console.log("error", e)
    }
  }

  async fetchCacheExcelCount() {
    try {
      let url = `cache-controller/getCount`;
      let res = await this.dataService.postData(url, { _id: this.assessmentId });
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.cacheCount = res.data.count || 0;
      this.updateExportMenuItems();

      console.log("this.cacheCount", this.cacheCount)
    } catch (e) {
      console.log("error", e)
    }
  }

  onChangeDropdown() {
    let params: any = {};
    if (this.dropType) {
      this.isFilterApplied = true;
      this.external = this.dropType.id !== 1;
      if (this.isChild) {
        this.page = 1;
        this.fetchData();
        return;
      }
      if (this.dropType.id == 1) {
        params = { external: false };
      }
      else {
        params = { external: true };
      }
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: params,
        queryParamsHandling: 'merge',
      });
    }
  }

  resetFilters() {
    this.dropType = null;
    this.external = null;
    this.searchText = '';
    this.isFilterApplied = false;
    if (this.isChild) {
      this.page = 1;
      this.fetchData();
      return;
    }
    const queryParams = { ...this.route.snapshot.queryParams };
    delete queryParams['external'];
    delete queryParams['searchText'];
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
    });
  }

  async fetchGraphData() {
    try {

      let url = `${this.from}-result/graph/${this.assessmentId}`;
      if (this.isRating) {
        url = url + "?courseId=" + this.courseId + "&ratingFor=" + this.ratingFor + "&ratingForID=" + this.ratingForID;
      }

      console.log("URL", url)

      let res = await this.dataService.getData(url);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.graphData = res.data;
      this.applyGraphRowTransforms(this.graphData);

      // Sort: external questions first (by order), then internal questions (by order).
      // External questions are normally filtered server-side for the screen view, but
      // sorting defensively keeps any future opt-in path grouped instead of interleaved.
      this.graphData.sort(this.compareInternalThenExternal);


      console.log("this.graphData", this.graphData)

    } catch (e) {
      console.log("Error", e)
    }
  }

  /**
   * Comparator used to render external (ungraded) questions first, in their own order,
   * followed by internal (regular) assessment questions in their assessment order.
   * Rows are tagged with `isExternal` by `applyGraphRowTransforms`.
   */
  private compareInternalThenExternal = (a: any, b: any): number => {
    const aExt = a && a.isExternal ? 0 : 1;
    const bExt = b && b.isExternal ? 0 : 1;
    if (aExt !== bExt) return aExt - bExt;
    return (a?.order || 0) - (b?.order || 0);
  };

  /**
   * Applies the per-question presentation transforms (text replacement, chart payload
   * shaping, type remapping for matrix/rank/drag/calendar/OU tree, info banners, etc.)
   * to a list of raw rows returned by `*-result/graph` or `assessment-result/getBulkGraph`.
   *
   * Mutates each row in place and also returns the same array, so callers can chain.
   * Used by both `fetchGraphData()` (screen view) and `exportToPDFwithData()`
   * (PDF/PPT export) so the two paths stay in sync.
   */
  private applyGraphRowTransforms(rows: any[]): any[] {
    if (!Array.isArray(rows)) {
      return [];
    }

    const internalQuestions = (this.assessment && this.assessment.questions) || [];
    const externalQuestions = (this.assessment && this.assessment.externalQuestions) || [];
    const allQuestions = [...internalQuestions, ...externalQuestions];

    const matchQuestion = (data: any, pool: any[]) => {
      const cleanStr = (s: any) => s ? s.toString().replace(/[\u200E\u200F]/g, '').trim().toLowerCase() : '';
      const gId = data._id ? data._id.toString() : '';
      const gText = cleanStr(data.questionText);
      return pool.find((aq: any) => {
        const aqId = aq._id ? aq._id.toString() : '';
        const aqCode = aq.questionCode ? aq.questionCode.toString() : '';
        const aqText = cleanStr(aq.questionText);
        return aqId === gId ||
               aqCode === gId ||
               aqText === gText ||
               gId === `${aqCode}_` ||
               gId === `${aqId}_` ||
               (aqCode && gId && (gId === aqCode || gId.split('_')[0] === aqCode)) ||
               (aqText && aqText === gText && gText.length > 5);
      });
    };

    rows.forEach(data => {
      // Prefer the backend's authoritative flag (set by getBulkGraph?includeExternal=true).
      // Fall back to local pool matching only when the field is absent (e.g. screen path).
      const backendIsExternal = typeof data.isExternal === 'boolean' ? data.isExternal : null;
      const qObj = backendIsExternal === true
        ? (matchQuestion(data, externalQuestions) || matchQuestion(data, allQuestions))
        : backendIsExternal === false
          ? (matchQuestion(data, internalQuestions) || matchQuestion(data, allQuestions))
          : matchQuestion(data, allQuestions);
      const isExternal = backendIsExternal !== null
        ? backendIsExternal
        : !!matchQuestion(data, externalQuestions);

      if (!qObj) {
        console.warn('PPT/PDF Matching Failed:', { id: data._id, text: data.questionText });
      }

      if (data._id) {
        data._id = this.replaceAlIsmWithAlSual(data._id);
      }
      if (data.questionText) {
        data.questionText = this.replaceAlIsmWithAlSual(data.questionText);
      }

      if (data.data && data.data.labels && Array.isArray(data.data.labels)) {
        data.data.labels = data.data.labels.map((label: any) => {
          return this.replaceAlIsmWithAlSual(label);
        });
      }
      if (data.graphData && data.graphData.labels) {
        if (Array.isArray(data.graphData.labels)) {
          data.graphData.labels = data.graphData.labels.map((label: any) => {
            if (Array.isArray(label)) {
              return label.map((l: any) => this.replaceAlIsmWithAlSual(l));
            }
            return this.replaceAlIsmWithAlSual(label);
          });
        }
      }

      try {
      // Question-type-specific branches must take precedence over the generic
      // 'bar' branch because backend returns type='bar' for several specialized
      // types (DRAG_DROP, DATE_TIME, CALENDAR) whose data shape doesn't fit
      // getBarGraph and crashes the entire transform.
      const specializedQuestionTypes = new Set([
        'DRAG_DROP', 'DATE_TIME', 'CALENDAR',
        'MULTI_SELECT_SCALE', 'MULTI_POINT_SCALE',
        'RANK_ORDER', 'OU_TREE_DROPDOWN',
        'SECTION_HEADING', 'SECTION_SUB_HEADING', 'PRESENTATION_TEXT',
      ]);
      if (data.type == 'bar' && !specializedQuestionTypes.has(data.questionType)) {
        data.graphData = this.getBarGraph(data.data, data.questionType);
      } else if (data.type == 'smile') {
        data.graphData = this.getSmileData(data.data, qObj);
      } else if (data.type == 'rate') {
        data.graphData = this.getStartData(data.data, qObj);
      } else if (data.questionType == "MULTI_SELECT_SCALE") {
        try {
          data.type = 'table'
          data.data = this.getMatrixData(data.data, qObj);
        } catch (error) {
          console.error('MULTI_SELECT_SCALE transform failed', error)
        }
      } else if (data.questionType == "MULTI_POINT_SCALE") {
        try {
          data.type = 'table'
          data.data = this.getMatrixData(data.data, qObj);
        } catch (error) {
          console.error('MULTI_POINT_SCALE transform failed', error)
        }
      } else if (data.questionType == "RANK_ORDER") {
        try {
          data.type = 'rank_order'
          data.data = this.getRankOrderSummary(data.meta || []);
          data.graphData = data.data;
        } catch (error) {
          console.error('RANK_ORDER transform failed', error)
        }
      } else if (data.questionType == "DRAG_DROP") {
        try {
          data.type = 'rank_order'
          data.data = this.getDragDropSummary(data.meta || []);
          data.graphData = data.data;
        } catch (error) {
          console.error('DRAG_DROP transform failed', error)
        }
      } else if (data.questionType == "CALENDAR") {
        data.type = 'calander';
      } else if (data.questionType == "OU_TREE_DROPDOWN") {
        data.type = 'text';
        if (!data.data?.datasets?.[0]?.data && Array.isArray(data.meta)) {
          data.data = {
            labels: [data.questionText],
            datasets: [{ data: data.meta.map((m: any) => [m?.selectedOu?.label ?? m?.value ?? '']) }]
          };
        } else if (data.data?.datasets?.[0]?.data) {
          data.data.datasets[0].data = (data.data.datasets[0].data || []).map((row: any) =>
            Array.isArray(row) ? row : [row]
          );
        }
        const ouRows = data.data?.datasets?.[0]?.data || [];
        const labelCounts: { [label: string]: number } = {};
        ouRows.forEach((row: any) => {
          const label = Array.isArray(row) ? (row[0] ?? '') : (row ?? '');
          if (label !== '' && label != null) {
            labelCounts[label] = (labelCounts[label] || 0) + 1;
          }
        });
        const ouLabels = Object.keys(labelCounts);
        data.graphData = {
          labels: ouLabels,
          datasets: [{
            label: this.translate('Number of respondents'),
            data: ouLabels.map(l => labelCounts[l]),
            backgroundColor: this.chartColors.map(c => '#' + c).slice(0, ouLabels.length)
          }]
        };
      } else if (data.questionType === 'SECTION_HEADING' || data.questionType === 'SECTION_SUB_HEADING' || data.questionType === 'PRESENTATION_TEXT') {
        data.type = 'info';
      }
      } catch (rowErr) {
        console.error('PPT/PDF row transform failed', { id: data?._id, type: data?.type, qt: data?.questionType, isExternal, err: rowErr });
      }

      data.order = qObj ? (qObj.order ?? 999) : 999;
      data.isExternal = isExternal;
    });

    return rows;
  }

  multiselectGraph(data: any): ChartDataset[] | null {
    if (!Array.isArray(data)) {
      data = [data]
    }

    const chartData: { labels: string[], values: number[] }[] = data.map((question: Question) => {
      if (!question.meta || !Array.isArray(question.meta)) {
        console.error('Error: Invalid data structure.');
        return null;
      }

      return question.meta.map((item: MetaItem) => {
        const columns: string[] = item.columns.map((column: string) => column);
        const values: number[] = item.fields.map((field: any) => field.value.length);
        return {
          labels: columns,
          values: values
        };
      });
    }).flat().filter(Boolean) as { labels: string[], values: number[] }[];

    // Creating chart datasets
    const datasets = chartData.map(item => {
      return {
        labels: item.labels,
        data: item.values,
        backgroundColor: 'rgba(128, 45, 126, 0.5)', // Logo Plum (rgba)
        borderColor: '#802d7e',                   // Logo Plum
        borderWidth: 1
      };
    });
    return datasets;
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const formattedDate = `${hours}:${minutes} ${day}-${month}-${year} `;
    return formattedDate;
  }

  getBarGraph(graphdata: any, name: string): any {
    const colorPalette = ['#802d7e', '#1b75bb', '#5b5095', '#2e3171', '#3d2b63'];
    const multiColorPalette: any = {
      "Correct": '#1b75bb', // Logo Blue
      "Incorrect": '#802d7e' // Logo Plum
    };

    if (Array.isArray(graphdata.datasets)) {
      const processedDatasets = graphdata.datasets.map((dataset: any, datasetIndex: number) => {
        const sortedData = dataset.data
          .map((value: number, index: number) => ({ value, label: dataset.labels[index] }))
          .sort((a: { value: number; }, b: { value: number; }) => b.value - a.value);

        const sortedValues = sortedData.map((item: { value: any; }) => item.value);
        const sortedLabels = sortedData.map((item: { label: any; }) => item.label);

        let dataPercentage = sortedValues.map((value: number) => {
          if (this.totalUserResults > 0) {
            return ((value / this.totalUserResults) * 100).toFixed(2);
          }
          return '0.00';
        });
        // Replace "الاسم" with "السؤال" in labels at the source
        let concatenatedLabels = sortedValues.map((data: string, index: number) => {
          return this.replaceAlIsmWithAlSual(sortedLabels[index]);
        });
        let backgroundColors = sortedValues.map(() => multiColorPalette[dataset.label] || '#cccccc');

        return {
          backgroundColor: backgroundColors,
          label: dataset.label,
          data: dataPercentage,
          counts: sortedValues
        };
      });

      // Replace "الاسم" with "السؤال" in labels at the source
      const processedLabels = Array.isArray(graphdata.labels)
        ? graphdata.labels.map((label: any) => this.replaceAlIsmWithAlSual(label))
        : this.replaceAlIsmWithAlSual(graphdata.labels);

      return {
        labels: this.labelmaker(processedLabels),
        datasets: processedDatasets
      };
    } else if (typeof graphdata.datasets === 'object') {
      const sortedData = graphdata.datasets.data
        .map((value: number, index: number) => ({ value, label: graphdata.label[index] }))
        .sort((a: { value: number; }, b: { value: number; }) => b.value - a.value);

      const sortedValues = sortedData.map((item: { value: any; }) => item.value);
      const sortedLabels = sortedData.map((item: { label: any; }) => item.label);

      let dataPercentage = sortedValues.map((value: number) => {
        if (this.totalUserResults > 0) {
          return ((value / this.totalUserResults) * 100).toFixed(2);
        }
        return '0.00';
      });
      // Replace "الاسم" with "السؤال" in labels at the source
      let concatenatedLabels = sortedValues.map((data: string, index: number) => {
        return this.replaceAlIsmWithAlSual(sortedLabels[index]);
      });
      let backgroundColors = sortedValues.map((_: any, index: number) => colorPalette[index % colorPalette.length]);

      return {
        labels: this.labelmaker(concatenatedLabels),
        datasets: [
          {
            backgroundColor: backgroundColors,
            label: graphdata.datasets.label,
            data: dataPercentage,
            counts: sortedValues
          }
        ]
      };
    }
  }

  labelmaker(inputArray: string[]): string[][] {
    const result: string[][] = [];
    inputArray.forEach(item => {
      // Show full text without truncation
      result.push([item]);
    });
    return result;
  }

  getSmileData(data: any, questionObj?: any) {
    let labels = data?.label || data?.labels || [];
    let images = data?.label_images || data?.images || [];
    let datasets = data?.datasets?.data || [];
    
    // Fallback to assessment metadata if results are empty
    if (labels.length === 0 && questionObj?.meta) {
      const fields = questionObj.meta.fields || questionObj.meta.options || [];
      labels = fields.map((f: any) => f.label || f.placeholder || f.text || '');
      images = fields.map((f: any) => f.image || f.icon || '');
      
      // If still empty, try columns
      if (labels.length === 0 && questionObj.meta.columns) {
        labels = questionObj.meta.columns;
      }
      datasets = labels.map(() => 0);
    }

    const maxLength = Math.max(labels.length, images.length, datasets.length);
    if (maxLength === 0) return [];

    return Array.from({ length: maxLength }, (_, index) => {
      const label = labels[index] || '';
      const image = images[index] || '';
      const rawCount = datasets[index] || 0;
      const percentage = this.totalUserResults > 0 ? ((rawCount / this.totalUserResults) * 100).toFixed(2) : '0.00';
      return { label, image, count: percentage, rawCount };
    });
  }

  getStartData(data: any, questionObj?: any) {
    let labels = data?.label || data?.labels || [];
    let datasets = data?.datasets?.data || [];

    // Fallback to assessment metadata if results are empty
    if (labels.length === 0 && questionObj?.meta) {
      const fields = questionObj.meta.fields || questionObj.meta.options || [];
      labels = fields.map((f: any) => f.label || f.placeholder || f.text || '');
      
      // If still empty, try columns
      if (labels.length === 0 && questionObj.meta.columns) {
        labels = questionObj.meta.columns;
      }
      datasets = labels.map(() => 0);
    }
    
    const maxLength = Math.max(labels.length, datasets.length);
    if (maxLength === 0) return [];

    return Array.from({ length: maxLength }, (_, index) => {
      const label = labels[index] || '';
      const value = datasets[index] || 0;
      return { label, value, rawCount: value };
    });
  }




  onPageChange(event: any, index: number) {
    if (this.assessment.accessType == 'BY_ACCOUNT') {
      if (this.activeResultTabIndex != index) {
        return;
      }
    }
    this.isFilterApplied = true;
    this.first = event.first;
    this.rows = event.rows;
    this.page = event.page + 1
    this.currentQBankId = "";
    if (this.isChild) {
      this.fetchData();
      return;
    }

    const params = { page: this.page, rows: this.rows };


    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: params,
      queryParamsHandling: 'merge',
    });
  }

  async regenerateAttempts() {
    try {
      this.regenAttempt = true;
      let url = `${this.from}-attempt/${this.assessmentId}`;
      let res = await this.dataService.postData(url, '');
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.generateResults();
    } catch (e) {
      console.log("error", e)
    }
  }

  async generateResults() {
    try {
      let res = await this.dataService.postData(
        `${this.from}-result/regenerate/${this.assessmentId}`,
        ''
      );
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        this.regenAttempt = false;
        return;
      }

      this.messageService.add({
        severity: 'success',
        summary: this.translate('success'),
        detail: this.translate('Results Genereted Successfully')
      })
      this.regenAttempt = false;
    } catch (e) { }
  }

  public async exportExcelCache() {
    this.downloadExcelCache = true
    let cleanData: any = await this.fetchCacheExcelData();
    let updatedDataArray;
    if (this.from == 'assessment') {
      updatedDataArray = cleanData.map((item: any) => {
        const { question, email, attendance, externalName, externalFields, score, total, percentage, percentageCriteria } = item;

        let updatedItem: any = {
          'الاسم': externalName ? externalName : '-',
          'البريد الإلكتروني': email,
          ...externalFields,
          'الحضور': attendance ? this.translate(attendance) : '-',
          'الدرجة': this.formatScore(score),
          'الدرجة الكلية': total,
          'النسبة': this.formatScore(percentage),
          'التقدير': percentageCriteria
        };
        updatedItem = { ...updatedItem, ...question };
        return updatedItem;
      });
    }
    else {
      updatedDataArray = cleanData.map((item: any) => {
        const { question, email, attendance, externalName, externalFields } = item;
        let updatedItem: any = {
          'الاسم': externalName ? externalName : '-',
          'البريد الإلكتروني': email,
          ...externalFields,
          'الحضور': attendance ? this.translate(attendance) : '-'
        };
        updatedItem = { ...updatedItem, ...question };
        return updatedItem;
      });
    }

    this.exportService.exportContentUpdateExcel(updatedDataArray, this.assessment.name);
    this.downloadExcelCache = false
  }

  public async exportExcel() {
    this.downloadExcel = true
    let cleanData: any = await this.fetchExcelData()
    let updatedDataArray;
    if (this.from == 'assessment') {
      updatedDataArray = cleanData.map((item: any) => {
        const { question, email, attendance, externalName, externalFields, score, total, percentage, percentageCriteria } = item;
        let updatedItem: any = {
          'الاسم': externalName ? externalName : '-',
          'البريد الإلكتروني': email,
          ...externalFields,
          'الحضور': attendance ? this.translate(attendance) : '-',
          'الدرجة': this.formatScore(score),
          'الدرجة الكلية': total,
          'النسبة': this.formatScore(percentage) + '%',
          'التقدير': percentageCriteria
        };
        updatedItem = { ...updatedItem, ...question };
        return updatedItem;
      });
    }
    else {
      updatedDataArray = cleanData.map((item: any) => {
        const { question, email, attendance, externalName, externalFields } = item;
        let updatedItem: any = {
          'الاسم': externalName ? externalName : '-',
          'البريد الإلكتروني': email,
          ...externalFields,
          'الحضور': attendance ? this.translate(attendance) : '-'
        };
        updatedItem = { ...updatedItem, ...question };
        return updatedItem;
      });
    }

    this.exportService.exportContentUpdateExcel(updatedDataArray, this.assessment.name);
    this.downloadExcel = false
  }

  public async exportPdf() {
    if (this.isAnonymousAssessment()) {
      this.messageService.add({
        severity: 'warn',
        summary: this.translate('Warning'),
        detail: this.translate('Anonymous survey PDF export is disabled'),
      });
      return;
    }
    this.downloadPdf = true;
    let cleanData: any = await this.fetchPdfData();

    let pageOrientation: any = 'portrait';
    let updatedDataArray = cleanData.map((item: any) => {

      let updatedItem: any;

      if (this.from == 'assessment') {
        pageOrientation = 'landscape'
        const { name, email, phone, gender, score, totalMarks, criteria, timeTaken, attemptEndDate, percentage, questions } = item;


        updatedItem = {
          'التقدير': this.reverseWordsForRTL(criteria || '-'),
          'المستغرق  الوقت': this.reverseWordsForRTL(timeTaken || '-'),
          'النسبة': this.formatScore(percentage) + " %" || '-',
          [`${totalMarks} من  الدرجة`]: this.formatScore(score || '-'),
          'الجنس': this.reverseWordsForRTL(gender || '-'),
          'الهاتف  المحمول  رقم': this.reverseWordsForRTL(phone || '-'),
          'الإلكتروني  البريد': this.reverseWordsForRTL(email || '-'),
          'الاسم': this.reverseWordsForRTL(this.getName(name) || '-'),
        };
      }
      else {
        const { name, email, phone, gender, timeTaken } = item;
        updatedItem = {
          'الجنس': this.reverseWordsForRTL(gender || '-'),
          'الهاتف  المحمول  رقم': this.reverseWordsForRTL(phone || '-'),
          'الإلكتروني  البريد': this.reverseWordsForRTL(email || '-'),
          'الاسم': this.reverseWordsForRTL(this.getName(name) || '-'),
        };
      }
      return updatedItem;
    });

    console.log("updatedDataArray", updatedDataArray)

    this.exportService.exportToPdf(updatedDataArray, this.reverseWordsForRTL(this.assessment.name || ''), pageOrientation);
    this.downloadPdf = false
  }

  public async exportPdfFormatExcel() {
    this.downloadPdfExcel = true;
    let cleanData: any = await this.fetchPdfData();

    let pageOrientation: any = 'portrait';
    let updatedDataArray = cleanData.map((item: any) => {

      let updatedItem: any;

      if (this.from == 'assessment') {
        pageOrientation = 'landscape'
        const { name, email, phone, gender, score, totalMarks, criteria, timeTaken, attemptEndDate, percentage, questions } = item;


        updatedItem = {
          'الاسم': this.getName(name) || '-',
          'البريد الإلكتروني': email || '-',
          'رقم الهاتف المحمول': phone || '-',
          'الجنس': gender || '-',
          [`الدرجة من ${totalMarks}`]: this.formatScore(score) || '-',
          'النسبة': this.formatScore(percentage) + " %" || '-',
          'الوقت المستغرق': timeTaken || '-',
          'التقدير': criteria || '-',
        };
      }
      else {
        const { name, email, phone, gender, timeTaken } = item;
        updatedItem = {
          'الاسم': this.getName(name) || '-',
          'البريد الإلكتروني': email || '-',
          'رقم الهاتف المحمول': phone || '-',
          'الجنس': gender || '-',
        };
      }
      return updatedItem;
    });

    console.log("updatedDataArray", updatedDataArray)

    this.exportService.exportContentUpdateExcel(updatedDataArray, this.assessment.name);
    this.downloadPdfExcel = false
  }

  isArabicText(text: string): boolean {
    const arabicPattern = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/;
    return arabicPattern.test(text);
  }

  reverseWordsForRTL(text: string): string {
    if (this.isArabicText(text)) {
      return text.split(' ').reverse().join('  ');
    }
    return text;
  }

  public async exportCorrectWrongExcel() {
    this.downloadCWExcel = true
    let cleanData: any = await this.fetchBulkExcelData()
    let updatedDataArray;
    updatedDataArray = cleanData.map((item: any) => {
      const { question, correct, incorrect } = item;
      // Replace "الاسم" with "السؤال" in question text
      const updatedQuestion = this.replaceAlIsmWithAlSual(question);
      let updatedItem: any = {
        'السؤال': updatedQuestion,
        'الإجابات الصحيحة': correct,
        'الإجابات الخاطئة': incorrect
      };
      return updatedItem;
    });

    this.exportService.exportContentUpdateExcel(updatedDataArray, this.assessment.name);
    this.downloadCWExcel = false
  }

  handleSelectedUsersChange(selectedUsers: string[]): void {
    this.selectedUsers = selectedUsers;
  }


  async sendEmail() {
    if (this.selectedUsers.length == 0) {
      this.emailModal = false;
      this.messageService.add({ severity: 'error', summary: this.translate('error'), detail: this.translate('Please Select Users to Send Email') })
      return false;
    }

    if (this.emailText == "") {
      this.messageService.add({ severity: 'error', summary: this.translate('error'), detail: this.translate('Please Enter Email Text') })
      return false;
    }

    if (this.emailLink == "") {
      this.messageService.add({ severity: 'error', summary: this.translate('error'), detail: this.translate('Please Enter Email Link') })
      return false;
    }
    const parts = this.emailLink.split('/attempt/');
    const id = parts[1] ? parts[1].split('?')[0] : null;

    try {
      this.skelition = true;
      let data = {
        _id: id,
        emailText: this.emailText,
        emailLink: this.emailLink,
        emails: this.selectedUsers
      }
      let res = await this.dataService.postData(`${this.from}-result/sendEmailUsers`, data);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.emailModal = false;
      this.emailLink = "";
      this.emailText = "";
      this.selectedUsers = [];
      this.skelition = false;
    } catch (error) {
      this.skelition = false;
      console.log(error);
    }
    return true;
  }

  async sendCertificate() {
    if (this.selectedUsers.length == 0) {
      const confirmed = await this.confirm({
        message: this.translate('Are you sure you want to send Certificate to All Users'),
        header: this.translate('Confirmation message'),
        icon: 'pi pi-exclamation-triangle',
        action: async () => {
          this.sendCertificateConfirm();
        },
        reject: async () => {
          return false;
        }
      });
      return confirmed;
    }
    else {
      await this.sendCertificateConfirm();
      return;
    }
  }

  async sendCertificateConfirm() {
    try {
      this.skelition = true;
      let data = {
        assessmentId: this.assessmentId,
        emails: this.selectedUsers
      }
      let res = await this.dataService.postData(`${this.from}-result/sendCertEmailUsers`, data);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.selectedUsers = [];
      this.skelition = false;
    } catch (error) {
      this.skelition = false;
      console.log(error);
    }
  }

  async deleteUsers() {
    if (this.selectedUsers.length === 0) {
      this.emailModal = false;
      this.messageService.add({
        severity: 'error',
        summary: this.translate('error'),
        detail: this.translate('Please Select Users to Send Email')
      });
      return false;
    }

    const confirmed = await this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: async () => {
        try {
          this.skelition = true;
          const data = {
            _id: this.assessmentId,
            emails: this.selectedUsers
          };
          const res = await this.dataService.postData(`${this.from}-result/deleteUsers`, data);

          if (res.error) {
            this.messages = [
              { severity: 'error', summary: this.translate('error'), detail: res.msg }
            ];
            return;
          }
          this.selectedUsers = [];
          this.ngOnInit();
        } catch (error) {
          console.log(error);
        } finally {
          this.skelition = false;
        }
      }
    });

    return confirmed;
  }

  formatScore(value: any) {
    const num = Number(value);
    if (isNaN(num)) {
      return '-';
    }
    if (num % 1 === 0 || num.toFixed(2).endsWith('.00')) {
      return Math.trunc(num);
    } else {
      return num.toFixed(2);
    }
  }

  confirm(params: any): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.confirmationService.confirm({
        message: params.message,
        header: params.header,
        icon: params.icon,
        acceptLabel: 'نعم',
        rejectLabel: 'لا',
        accept: async () => {
          try {
            await params.action();
            resolve(true);
          } catch (error) {
            console.error("Confirmation action failed", error);
            reject(false);
          }
        },
        reject: (type: any) => {
          switch (type) {
            case ConfirmEventType.REJECT:
            case ConfirmEventType.CANCEL:
            default:
              resolve(false);
              break;
          }
        }
      });
    });
  }

  getName(name: any): string {
    if (typeof name === 'object' && name !== null) {
      return Object.values(name).join(' ');
    } else {
      return name;
    }
  }

    // Replace "الاسم" with "السؤال" in any text, strip HTML tags, and handle RTL ordering for English questions
    replaceAlIsmWithAlSual(text: any): string {
      if (!text) return text || '';
      let result = text.toString().replace(/<[^>]*>/g, '');
      // Only perform replacement for assessments, keep "Name" for surveys
      if (this.from !== 'survey') {
          result = result.replace(/الاسم/g, 'السؤال');
      }
      
      // If the text ends with a question mark and starts with LTR characters, add an LRM to fix RTL alignment
      if (result.endsWith('?') && /^[a-zA-Z0-9]/.test(result)) {
        return '\u200E' + result + '\u200E'; // Wrap in LRM
      }
      return result;
    }


  // Helper function for Arabic text (returns text as-is)
  fixArabicText(text: string): string {
    if (!text) return text;
    // Reverse word order: "like i like this" -> "this like i like"
    const words = text.trim().split(/\s+/).filter(word => word.length > 0);
    let temp = words.reverse()
    let y = words.slice(2);
    let s

    if (temp.length == 2) {
      s = words[0] + " " + words[1] + " ";
    } else if (temp.length == 3) {
      s = words[0] + " " + words[1] + " " + words[2] + " ";;
    } else if (temp.length == 4) {
      s = " " + words[0] + " " + words[1] + " " + words[2] + " " + words[3] + " ";
    } else if (temp.length == 5) {
      s = " " + words[0] + " " + words[1] + " " + words[2] + " " + words[3] + " " + words[4] + " ";
    } else if (temp.length == 6) {
      s = " " + words[0] + " " + words[1] + " " + words[2] + " " + words[3] + " " + words[4] + " " + words[5] + " ";
    } else if (temp.length == 7) {
      s = " " + words[0] + " " + words[1] + " " + words[2] + " " + words[3] + " " + words[4] + " " + words[5] + " " + words[6] + " ";
    } else if (temp.length == 8) {
      s = " " + words[0] + " " + words[1] + " " + words[2] + " " + words[3] + " " + words[4] + " " + words[5] + " " + words[6] + " " + words[7] + " ";
    } else if (temp.length == 9) {
      s = " " + words[0] + " " + words[1] + " " + words[2] + " " + words[3] + " " + words[4] + " " + words[5] + " " + words[6] + " " + words[7] + " " + words[8] + " ";
    } else if (temp.length == 10) {
      s = " " + words[0] + " " + words[1] + " " + words[2] + " " + words[3] + " " + words[4] + " " + words[5] + " " + words[6] + " " + words[7] + " " + words[8] + " " + words[9] + " ";
    } else if (temp.length == 11) {
      s = " " + words[0] + " " + words[1] + " " + words[2] + " " + words[3] + " " + words[4] + " " + words[5] + " " + words[6] + " " + words[7] + " " + words[8] + " " + words[9] + " " + words[10] + " ";
    } else if (temp.length == 12) {
      s = " " + words[0] + " " + words[1] + " " + words[2] + " " + words[3] + " " + words[4] + " " + words[5] + " " + words[6] + " " + words[7] + " " + words[8] + " " + words[9] + " " + words[10] + " " + words[11] + " ";
    } else if (temp.length == 13) {
      s = " " + words[0] + " " + words[1] + " " + words[2] + " " + words[3] + " " + words[4] + " " + words[5] + " " + words[6] + " " + words[7] + " " + words[8] + " " + words[9] + " " + words[10] + " " + words[11] + " " + words[12] + " ";
    } else if (temp.length == 14) {
      s = " " + words[0] + " " + words[1] + " " + words[2] + " " + words[3] + " " + words[4] + " " + words[5] + " " + words[6] + " " + words[7] + " " + words[8] + " " + words[9] + " " + words[10] + " " + words[11] + " " + words[12] + " " + words[13] + " ";
    } else if (temp.length == 15) {
      s = " " + words[0] + " " + words[1] + " " + words[2] + " " + words[3] + " " + words[4] + " " + words[5] + " " + words[6] + " " + words[7] + " " + words[8] + " " + words[9] + " " + words[10] + " " + words[11] + " " + words[12] + " " + words[13] + " " + words[14] + " ";
    } else if (temp.length == 16) {
      s = " " + words[0] + " " + words[1] + " " + words[2] + " " + words[3] + " " + words[4] + " " + words[5] + " " + words[6] + " " + words[7] + " " + words[8] + " " + words[9] + " " + words[10] + " " + words[11] + " " + words[12] + " " + words[13] + " " + words[14] + " " + words[15] + " ";
    } else if (temp.length == 17) {
      s = " " + words[0] + " " + words[1] + " " + words[2] + " " + words[3] + " " + words[4] + " " + words[5] + " " + words[6] + " " + words[7] + " " + words[8] + " " + words[9] + " " + words[10] + " " + words[11] + " " + words[12] + " " + words[13] + " " + words[14] + " " + words[15] + " " + words[16] + " ";
    } else if (temp.length == 18) {
      s = " " + words[0] + " " + words[1] + " " + words[2] + " " + words[3] + " " + words[4] + " " + words[5] + " " + words[6] + " " + words[7] + " " + words[8] + " " + words[9] + " " + words[10] + " " + words[11] + " " + words[12] + " " + words[13] + " " + words[14] + " " + words[15] + " " + words[16] + " " + words[17] + " ";
    } else if (temp.length == 19) {
      s = " " + words[0] + " " + words[1] + " " + words[2] + " " + words[3] + " " + words[4] + " " + words[5] + " " + words[6] + " " + words[7] + " " + words[8] + " " + words[9] + " " + words[10] + " " + words[11] + " " + words[12] + " " + words[13] + " " + words[14] + " " + words[15] + " " + words[16] + " " + words[17] + " " + words[18] + " ";
    } else if (temp.length == 20) {
      s = " " + words[0] + " " + words[1] + " " + words[2] + " " + words[3] + " " + words[4] + " " + words[5] + " " + words[6] + " " + words[7] + " " + words[8] + " " + words[9] + " " + words[10] + " " + words[11] + " " + words[12] + " " + words[13] + " " + words[14] + " " + words[15] + " " + words[16] + " " + words[17] + " " + words[18] + " " + words[19] + " ";
    } else {
      s = " " + words[0] + " " + y.join(' ')
    }

    return s;
  }



  initializeMenuItems() {
    this.updateExportMenuItems();
  }

  updateExportMenuItems() {
    this.exportMenuItems = [
      {
        label: this.translate('Download Excel'),
        icon: 'fa-regular fa-file-excel',
        command: () => this.exportExcel()
      },
      {
        label: this.translate('Download Excel (PDF Format)'),
        icon: 'fa-regular fa-file-excel',
        command: () => this.exportPdfFormatExcel()
      },
    ];

    if (!this.isAnonymousAssessment()) {
      this.exportMenuItems.push({
        label: this.translate('Download PDF'),
        icon: 'fa-regular fa-file-pdf',
        command: () => this.exportPdf()
      });
    }

    this.exportMenuItems.push(
      {
        label: this.translate('Download PowerPoint'),
        icon: 'fa-regular fa-file-powerpoint',
        command: () => this.exportToPPT()
      },
      {
        label: this.translate('Download PDF with Data'),
        icon: 'fa-regular fa-file-pdf',
        command: () => this.exportToPDFwithData()
      }
    );

    // Add additional options if available
    if (this.cacheCount > 0) {
      this.exportMenuItems.push({
        label: `${this.translate('Download Cache Attempts')} (${this.cacheCount})`,
        icon: 'fa-regular fa-file-excel',
        command: () => this.exportExcelCache()
      });
    }

    if (this.from === 'assessment') {
      this.exportMenuItems.push({
        label: this.translate('Correct and Incorrect Answers Statistics'),
        icon: 'fa-regular fa-file-excel',
        command: () => this.exportCorrectWrongExcel()
      });
    }

    if (this.from === 'assessment') {
      this.exportMenuItems.push({
        label: this.translate("the list of users who have attempted multiple times"),
        icon: 'fa-regular fa-file-excel',
        command: () => this.exportToPPTForMultitakers()
      })
    }


  }

  public async exportToPPTForMultitakers() {
    console.log(this.totalGradesData[3].listOfMuliTakers);
    this.downloadExcel = true
    let cleanData: any = this.totalGradesData[3].listOfMuliTakers;
    let updatedDataArray = cleanData.map((item: any) => {
      const { _id, name, sum, assessments } = item;
      let updatedItem: any = {
        'الاسم': name ? name : '-',
        'البريد الإلكتروني': _id,
        "عدد المرات": sum ? sum : '-',
        'الاختبارات': assessments ? assessments.join(', ') : '-'
      };
      return updatedItem;
    });

    this.exportService.exportContentUpdateExcel(updatedDataArray);
    this.downloadExcel = false
  }

  getRankOrderSummary(meta: any[]): any {
    if (!meta || meta.length === 0) return { labels: [], distribution: {}, maxRank: 0, ranks: [] };
    const labelScores: { [key: string]: number } = {};
    const labelCounts: { [key: string]: number } = {};
    const distribution: { [label: string]: { [rank: number]: number } } = {};
    let maxRank = 0;

    meta.forEach(response => {
      if (response.fields && Array.isArray(response.fields)) {
        response.fields.forEach((f: any) => {
          const rank = parseInt(f.value);
          if (!isNaN(rank) && rank > 0) {
            labelScores[f.label] = (labelScores[f.label] || 0) + rank;
            labelCounts[f.label] = (labelCounts[f.label] || 0) + 1;

            if (!distribution[f.label]) distribution[f.label] = {};
            distribution[f.label][rank] = (distribution[f.label][rank] || 0) + 1;
            if (rank > maxRank) maxRank = rank;
          }
        });
      }
    });

    const averageRanks = Object.keys(labelScores).map(label => ({
      label,
      avg: labelScores[label] / labelCounts[label]
    }));

    averageRanks.sort((a, b) => a.avg - b.avg);

    return {
      labels: averageRanks.map(item => item.label),
      distribution: distribution,
      maxRank: maxRank,
      ranks: Array.from({ length: maxRank }, (_, i) => i + 1)
    };
  }

  getDragDropSummary(meta: any[]): any {
    if (!meta || meta.length === 0) return { labels: [], distribution: {}, maxRank: 0, ranks: [] };
    const labelScores: { [key: string]: number } = {};
    const labelCounts: { [key: string]: number } = {};
    const distribution: { [label: string]: { [rank: number]: number } } = {};
    let maxRank = 0;

    meta.forEach(response => {
      const fields = response.orderedFields || response.fields;
      if (fields && Array.isArray(fields)) {
        fields.forEach((f: any, index: number) => {
          const rankValue = parseInt(f.value);
          const rank = !isNaN(rankValue) && rankValue > 0 ? rankValue : (index + 1);

          labelScores[f.label] = (labelScores[f.label] || 0) + rank;
          labelCounts[f.label] = (labelCounts[f.label] || 0) + 1;

          if (!distribution[f.label]) distribution[f.label] = {};
          distribution[f.label][rank] = (distribution[f.label][rank] || 0) + 1;
          if (rank > maxRank) maxRank = rank;
        });
      }
    });

    const averageRanks = Object.keys(labelScores).map(label => ({
      label,
      avg: labelScores[label] / labelCounts[label]
    }));

    averageRanks.sort((a, b) => a.avg - b.avg);

    return {
      labels: averageRanks.map(item => item.label),
      distribution: distribution,
      maxRank: maxRank,
      ranks: Array.from({ length: maxRank }, (_, i) => i + 1)
    };
  }

  getMatrixData(graphdata: any, questionObj?: any): any {
    // Robust fallback: If data is empty, try to get structure from the provided questionObj or assessment questions
    if ((!graphdata || !graphdata.datasets || graphdata.datasets.length === 0)) {
      const q = questionObj;
      if (q && q.meta) {
        const labels = q.meta.columns || q.meta.fields?.map((f: any) => f.label) || [];
        const datasets = q.meta.fields?.map((f: any) => {
          const fieldLabel = f.label || f.field?.label || '';
          return {
            label: fieldLabel,
            data: labels.map(() => '0.00'),
            counts: labels.map(() => 0)
          };
        }) || [];

        return {
          labels: this.labelmaker(labels.map((l: any) => this.replaceAlIsmWithAlSual(l))),
          datasets: datasets
        };
      }
    }

    if (graphdata && Array.isArray(graphdata.datasets) && graphdata.datasets.length > 0) {


      const processedDatasets = graphdata.datasets.map((dataset: any) => {
        let dataPercentage = dataset.data.map((value: number) => {
          if (this.from === 'survey') {
            return Number(value).toFixed(2);
          }
          if (this.totalUserResults > 0) {
            return ((value / this.totalUserResults) * 100).toFixed(2);
          }
          return '0.00';
        });
        let backgroundColors = dataset.data.map(() => '#1b75bb');

        return {
          backgroundColor: backgroundColors,
          label: dataset.label,
          data: dataPercentage,
          counts: dataset.data
        };
      });

      const processedLabels = Array.isArray(graphdata.labels)
        ? graphdata.labels.map((label: any) => this.replaceAlIsmWithAlSual(label))
        : this.replaceAlIsmWithAlSual(graphdata.labels);
      return {
        labels: this.labelmaker(processedLabels),
        datasets: processedDatasets
      };
    }
    return graphdata;
  }


  getQuestionStyle(data: any): { iconClass: string; bgColor: string; iconColor: string } {
    const qText = (data.questionText || '').toLowerCase();
    const type = data.type;

    let iconClass = 'sbc-icon sbc-icon-comment-text';
    let bgColor = '#eff6ff';
    let iconColor = '#1e3a8a';

    if (qText.includes('country') || qText.includes('residence') || qText.includes('location')) {
      iconClass = 'sbc-icon sbc-icon-earth-americas';
      bgColor = '#eff6ff';
      iconColor = '#1e3a8a';
    } else if (qText.includes('programming') || qText.includes('language') || qText.includes('code') || qText.includes('developer')) {
      iconClass = 'sbc-icon sbc-icon-code-simple';
      bgColor = '#fce7f3';
      iconColor = '#9d174d';
    } else if (
      qText.includes('rate') || qText.includes('experience') || qText.includes('satisfaction') ||
      qText.includes('scale') || type === 'rate' || type === 'smile'
    ) {
      iconClass = 'sbc-icon sbc-icon-stars';
      bgColor = '#f3e8ff';
      iconColor = '#6b21a8';
    } else if (qText.includes('image') || qText.includes('picture') || qText.includes('photo') || type === 'image-choice') {
      iconClass = 'sbc-icon sbc-icon-images';
      bgColor = '#fef3c7';
      iconColor = '#92400e';
    } else if (
      qText.includes('info') || qText.includes('user') || qText.includes('name') ||
      qText.includes('details') || type === 'text'
    ) {
      iconClass = 'sbc-icon sbc-icon-users-alt';
      bgColor = '#dcfce7';
      iconColor = '#166534';
    }

    return { iconClass, bgColor, iconColor };
  }

  getSmileIcon(label: string, index: number): string {
    const clean = (label || '').toLowerCase();
    
    if (clean.includes('راضٍ جداً') || clean.includes('راض جدا') || clean.includes('very satisfied') || clean.includes('excellent') || clean.includes('ممتاز')) {
      return 'assets/rating/s-1.svg';
    }
    if (clean.includes('راضٍ') || clean.includes('راض') || clean.includes('satisfied') || clean.includes('happy') || clean.includes('جيد')) {
      return 'assets/rating/s-2.svg';
    }
    if (clean.includes('محايد') || clean.includes('neutral') || clean.includes('acceptable') || clean.includes('مقبول')) {
      return 'assets/rating/s-3.svg';
    }
    if (clean.includes('مستاء جداً') || clean.includes('مستاء جدا') || clean.includes('very dissatisfied') || clean.includes('angry') || clean.includes('سيء جدا')) {
      return 'assets/rating/s-5.svg';
    }
    if (clean.includes('مستاء') || clean.includes('dissatisfied') || clean.includes('sad') || clean.includes('سيء')) {
      return 'assets/rating/s-4.svg';
    }

    // Fallbacks based on index
    if (index === 0) return 'assets/rating/s-5.svg';
    if (index === 1) return 'assets/rating/s-4.svg';
    if (index === 2) return 'assets/rating/s-3.svg';
    if (index === 3) return 'assets/rating/s-2.svg';
    if (index === 4) return 'assets/rating/s-1.svg';

    return 'assets/rating/s-3.svg';
  }
}interface MetaItem {
  columns: string[];
  fields: { value: any[] }[];
}

interface Question {
  meta: MetaItem[];
}

interface ChartDataset {
  labels: string[];
  data: number[];
  backgroundColor: string;
  borderColor: string;
  borderWidth: number;
}